import React, { lazy, Suspense, useCallback, useEffect, useMemo, useRef, useState } from "react";
import Draggable from "react-draggable";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";

import EobFormContext from "../context/EobFormContext";
import baseValidationSchema, { createValidationSchema } from "../schemas/eobFormValidationSchema";
import { useAdjustmentPopupManager } from "../hooks/useAdjustmentPopupManager";
import { getEmptyPlbAdjustment, initial835LiteValues, initialClaim, initialCorresValues, initialGridData, plbReasonOptions } from "../constants";
import AssignBackPopover from "../components/Popover/AssignBackPopover";
import FormPopover from "../components/Popover/FormPopover";
import AdditionalInfoPopover from "../components/Popover/AdditionalInfoPopover";
import ClaimSummary from "../components/claims/ClaimSummary";
import { createPropCode1, finalSubmitJobDetailsSequential, getAllLogDetails, getClaimDetailsFromNewGrid, getPlbDetailsFromNewGrid } from "../../../../redux/newGrid/actions.js";
import { useF7Search837Lookup } from "../hooks/useF7Search837Lookup";
import PatientSearch from "../components/F7EntityLookupComponent/PatientSearch";
import PayerPayeeSearch from "../components/F7EntityLookupComponent/PayerPayeeSearch";
import useF7PayerPayeeLookup from "../hooks/useF7PayerPayeeLookup";
import { useAdditionalInfo } from "../hooks/useAdditionalInfo";
import { buildEditedClaim, getQdxTransactionType, getTaskType, insertClaimAtIndex, isQdxTransactionType, manipulateTotalClaimPaidArray, mergeTwoClaims, processEditedClaimsUltraFast, removeEdiFromClaim, updateClaimAtIndex, updateFormValues, validateClaimCorresOneByOne, validateClaimLiteOneByOne, validateClaimOneByOne } from "../utils";
import { useTransactionTypes } from "../hooks/useTransactionTypes";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import BlockGrid from "../components/common/BlockGrid";
import { useToggle } from "../hooks/useToggle";
import { NEW_DATA_ENTRY, NEW_EDIT_WORK, NEW_QA_REVIEW } from "../../../../routeNames.js";
import {  validatePPFull } from "../schemas/validationSchemaPP";
import { eobFormCorresValidationSchema } from "../schemas/eobFormCorresValidationSchema";
import { eobFormPPValidationSchema } from "../schemas/eobFormPPValidationSchema";
import createFormLiteValidationSchema from "../schemas/eobFormLiteValidationSchema";
import { useFieldValidator } from "../hooks/useFieldValidatorCustom";
// import { deleteIndexedData } from "../../DataEntry/indexedDB";
import { getAutomationReset837ClaimNewGrid } from "../../../../redux/client/action.js";
import { assignJobFromQaV2, getJobStaffStatus, getSubJobUserData, rejectFile, rerunAutomationJob } from "../../../../redux/grid/action.js";
import { disablingGridLog, handleNavigateDashBoard, processEditedPlbAdjustments, processPlbAdjustments, sequestrationClaim, sequestrationServiceline } from "../utils/index1";
import QaErrorModal from "../components/common/QaErrorModal";
import Swal from "sweetalert2";
import Hotkey from "../../DataEntry/Grid/Elements/hotkey";
import { ResizableBox } from "react-resizable";
import useQaErrorTracking from "../hooks/useQaErrorTracking";
import moment from "moment";
import SuspenseTracker from "../components/common/SuspenseTracker";


const aditionalInfoFormik = {}

// Lazy loaded components
const GridHeader = lazy(() => import("./GridHeader"));
const GridFooter = lazy(() => import("./GridFooter"));
const Eob835 = lazy(() => import("./Eob835/eob835"));

const NewGrid = ({ setGridFormLoader,log_id,isViewOnllyGrid,jobData, totalPDFPages, jumpToPage,currentPdfPage,showAlert,loadNextJob,checkUserPermissions ,isViewAllPage,job_log=null ,isLoadFromCacheRef ,setToast,isSaveCurrentJobApi }) => {
  // ============================ STATE ============================ //
  // General
  const container = document.getElementById("grid-full-container");
  const pathname = window.location.pathname;
  const isQaScreen = pathname === NEW_QA_REVIEW
  const isMyworkScreen = pathname === NEW_DATA_ENTRY
  const isViewScreen = (pathname == NEW_EDIT_WORK + job_log)
  const isAutomation = useMemo(() => ((jobData?.is_automation_completed && jobData?.is_automation_job))
          , [jobData])
  const gridRef = useRef(null);
  const controlledPositionRef = useRef({ x: -10, y: 450 });
  const [qaErrorModal, setQaErrorModal] = useState(false);
  const [isDragEnabled, setIsDragEnabled] = useState(true);
  const [startClaimOrder, setStartClaimOrder] = useState(jobData?.grid_data?.claims?.length>0? jobData?.grid_data?.claims[0]?.order||1:1);
  const [paginateInputVal,setPagenateInputVal] = useState(jobData?.grid_data?.claims?.length>0? jobData?.grid_data?.claims[0]?.order||1:1)
  const [rerunLoad, setRerunLoad] = useState(false)
  const [componentLoadingState, setComponentLoadingState] = useState({isGridHeader:false,isEob835:false,isGridFooter:false})
  const [isPlbPaginateLoading, setisPlbPaginateLoading] = useState(false);

  //F7 Patient/Payee/Payer
  const [selectedPayerExce,setSelectedPayerExce] = useState()

  // Assign/Reject
  const [assignTooltip, setAssignTooltip] = useState(false);
    const [subJobOptions, setSubJobOptions] = useState([]);

  const [userStatus, setUserStatus] = useState({});
  const [assignTo, setAssignTo] = useState("");
  const assignRef = useRef(null);
  const [rejectPopupState, setRejectPopupState] = useState({ 
    open: false, 
    rejectLabel: null, 
    rejection_reason: null 
  });
  
  const [partialSavePopupState, setPartialSavePopupState] = useState({ 
    open: false, 
    saveLabel: null, 
    save_reason: null 
  });
  const rejectRef = useRef(null);

  // Check View/Info Modal
  const [showCheckView, setShowCheckView] = useState(false);
  const [infoModal, setInfoModal] = useState(false);

  // Claims/Service Lines
  const fullclaimTotal = useRef(jobData?.claims_total_amounts||[]);
  const [fullclaimData, setFullClaimData] = useState([]);
  const [activeclaim835Index, setActiveclaim835Index] = useState(0);
  const [showClaimSummary, setShowClaimSummary] = useState(false);
  const [moveClaimIndex, setMoveClaimIndex] = useState(null);
  const [activeserviceLineIndex, setActiveserviceLineIndex] = useState(0);
  const [isRarcCarcValidData, setIsRarcCarcValidData] = useState({ RARC: [], CARC: [] })
  const [handleReset837Loader, sethandleReset837Loader] = useState(false)
  const [handleLoadOrginalLoader, sethandleLoadOrginalLoader] = useState(false)
  const [hotKey, setHotKey] = useState(false);
  const [tableHeight, setTableHeight] = useState(300);
  const [triggerGridPos, setTriggerGridPos] = useState(false)

  const handleChangeGridPosition = (position_type = "default") => {
     const container = document.getElementById("grid-full-container");
    const box = document.getElementById("boxid-new");
    if (!container || !box) return;

    // Get container height and box height
    const containerHeight = container.clientHeight;
    const boxHeight = box.offsetHeight+50;

    // Bottom-left corner: x=0, y = containerHeight - boxHeight
    controlledPositionRef.current = {
      x: 0,
      y: window?.innerHeight - boxHeight,
    };

    // Force Draggable to re-render
    setTriggerGridPos((prev) => !prev);
  
  };

 const setFullClaimTotal = useCallback((data)=>{
    fullclaimTotal.current = data
 },[])
  // PLB Pagination
  const [plbPage, setPlbPage] = useState(1);
  const plbPaginatedata = useMemo(() => ({
    reasonOptions: plbReasonOptions,
    defaultPlbCount: 15,
    pageSize: 15,
    currentPage: plbPage,
  }), [plbPage]);


  //dbk Block grid hook
  const {isOpen:isBlockGrid, open:blockGrid, close:unblockGrid, } = useToggle()

  // ============================ FORM HOOKS ============================ //
  const contextValues = {
    totalPages:totalPDFPages,
    jobData,
    isSubJob: jobData?.is_sub_job,
    isFirstJob: jobData?.is_first_sub_job,
    isPayerPage: jobData?.client_level_customization?.is_payer_page_from_to,
    isPayeePage: jobData?.client_level_customization?.is_payee_page_from_to,
    isAdditional: jobData?.client_level_customization?.is_additional_info_available,
    isAdditionalInfoOptions: null,
    qdxTransaction: null,
    isRarcCarcValidData: isRarcCarcValidData,
  };

    const eobUseForm = useForm({
    defaultValues: {},
    // Use yup.lazy() to dynamically select the schema based on form values
    resolver: yupResolver(
        yup.lazy((values) => {
        // Access the transaction_type directly from the form values
        const { transaction_type } = values;

        if (transaction_type === "PATIENT_PAY") {
            return eobFormPPValidationSchema(contextValues);
        } else if (transaction_type === "CORRESPONDENCE") {
            return eobFormCorresValidationSchema(contextValues);
        }
        else if (transaction_type === "PAYMENT835_LITE") {
            return createFormLiteValidationSchema(contextValues);
        }
        else if (transaction_type === "PAYMENT835" || transaction_type ==='CORRESPONDENCE_835' || transaction_type==='PATIENT_PAY_835' ) {
            return createValidationSchema(contextValues);
        } else {
            // Return a default or fallback schema if no condition is met
            return yup.object().shape({});
        }
        })
    ),
    context: contextValues,
    shouldUnregister: false,
    });

  const {
    register: eobFormRegister,
    handleSubmit: eobFormHandleSubmit,
    reset: loadEobFormdata,
    setValue: eobFormSetValues,
    getValues: eobFormGetValues,
    formState: { errors: eobFormErrors },
    watch: eobFormValues,
    trigger: triggerEobValidation,
    setError: eobSetError,
    control,
    clearErrors
  } = eobUseForm;


  const values = eobFormValues();


  // Field Arrays
  const { fields: plb_adjustments, append: appendPlbAdjustment,remove:deletePlbAdjustment } = useFieldArray({ control, name: 'plb_adjustments' });
  const { fields: claimsData, move: moveClaim, remove: removeClaim, insert: addNewClaim, update: updateNewClaim, replace: replaceClaim } = useFieldArray({
    control,
    name: 'claims',
  });

  const updateMasterValues = useCallback((updates) => {
        loadEobFormdata((prev) => ({
        // ...prev,
        ...updates
        }));
  },[values]);
  
    const {
    handleQaErrorCheck,
    getGridEdited,
    hasQAErrorInHeader,
  } = useQaErrorTracking({eobFormSetValues,eobFormGetValues,isQaScreen});

// Additional Info
  const additionalInfoState = useAdditionalInfo({
    jobData,
    eobFormGetValues,
    eobFormSetValues,
    setIsDragEnabled,
    eobFormErrors, eobSetError,
    triggerEobValidation,
    job_log,
  });
  const {
    aditionalInfoRef,
    handleOpenAdditionalInfo,
    setValue:additionalInfoSetValue,
    getValues:additionalInfoGetValues,
    reasonData:resoncodeDropDrown,
    additionalModal,
  } = additionalInfoState

    const settingAdditionalInfoFormIsExcluded = () =>{
        const excludedPayerReason = resoncodeDropDrown?.find(item => item.label === "Excluded Payer");
        const currentValues = eobFormGetValues();
        const qdx_reason = currentValues?.qdx_reason||[]
        const hasExcludedPayer = qdx_reason?.some(item => item?.label === "Excluded Payer") || false;

        const additionalInfoValues = additionalInfoGetValues();
        const additionalInfoUpdates = {
        status: "INCOMPLETE",
        reason: (excludedPayerReason && !hasExcludedPayer) ? 
            [...(additionalInfoValues.reason || []), excludedPayerReason] : 
            (additionalInfoValues.reason || []),
        };

        // Apply updates
        updateFormValues(additionalInfoSetValue, additionalInfoValues, additionalInfoUpdates);

    }

  // F7 Patient Search
  const {
    setIsSwal,
    patientLookup,
    handleAccountNumberKeyUp,
    loading,
    setLoading,
    __handleSearchData837,
    patientValue,
    data_837,
    patientIndex,
    hoveredIndex,
    togglePatientHoverEnter,
    handlePatientIndex,
    patientValue1,
    patientValue2,
    setPatientValue,
    cl837Index,
    activate837,
    setData837,
    checkRef,
    handleCheckServiceLines,
    handleAllCheck,
    handleCleareOrSettSearched837filter,

} = useF7Search837Lookup({
  formEob:{values:values},
  jobData,
  0:activeclaim835Index,
  handleAutomationCalculate:(claim)=>{return claim},
  setSelectedPayerExce,
  isViewOnllyGrid,
  updateMasterValues,
  settingAdditionalInfoFormIsExcluded,
  showAlert,
  triggerEobValidation,
  isQaScreen
});

const {payerPayeeLookup,handlePayerPayeeF7KeyUp,
    handleSearchPayerPayee,
    togglePayerPayeeHoverEnter,
    activatePayerPayeeLookup,
    setPayerFocus,
    setPayerPayeeLookup,
    payerPayeeValue,
    payerPayeeData,
    payerPayeeIndex,
    setPayerPayeeValue,
    payerPayeeF7Type,
} = useF7PayerPayeeLookup({triggerEobValidation,showAlert,resoncodeDropDrown,eobFormGetValues,eobFormSetValues,additionalInfoGetValues,additionalInfoSetValue,formEob:{values:values},jobData,isViewOnllyGrid,handleChangeGridPosition,setLoading,setIsSwal,updateMasterValues,setSelectedPayerExce}) 

  const resetToInitailStates = ()=>{
        // setStartClaimOrder(1);
        // setPagenateInputVal(1);
        // setActiveclaim835Index(0);
        // setFullClaimData(initialGridData?.claims);
        // setFullClaimTotal([])
  }

const {transactionCorrespondance,transactionPayment835Lite,transactionPayment835,transactionPatientPay835,transactionPatientPay,processClaimsAutomation,calculateRemainingPlbPaidTotals,generatePaymentData}= useTransactionTypes({
    updateMasterValues,
    eobFormSetValues,
    eobFormGetValues,
    setControlledPosition:()=>{},
    setActiveclaim835Index,
    additionalInfoSetValue,
    additionalInfoValues:additionalInfoGetValues(),
    jobData,
    handleCleareOrSettSearched837filter,
    setFullClaimData,
    triggerEobValidation,
    resetToInitailStates,
    contextValues,
    eobSetError,
    clearErrors,
    setFullClaimTotal,
    setPagenateInputVal,
    isLoadFromCacheRef,
})
  const customFieldValidator = useFieldValidator(
    eobFormGetValues,
    eobSetError,
    clearErrors,
    contextValues
  )

// Adjustments Claim & ServiceLines
const serviceLineAdjustmentState = useAdjustmentPopupManager('serviceLine',setIsDragEnabled,values ,customFieldValidator);
const claimAdjustmentState = useAdjustmentPopupManager('claim',setIsDragEnabled,values ,customFieldValidator);


const {openPcPopup:openPcPopupServiceLine,closePcPopup:closePcPopupServiceLine,propCodeData:propCodeDataServiceLine} = serviceLineAdjustmentState
const {openPcPopup:openPcPopupClaim,closePcPopup:closePcPopupClaim,propCodeData:propCodeDataClaim} = claimAdjustmentState
  // ============================ HANDLERS ============================ //
  // Drag
  const onDrag = useCallback((_, position) => {
    controlledPositionRef.current = { x: position.x, y: position.y };
        setTriggerGridPos((prev) => !prev);

  }, []);

  // Add PLB Adjustment
  const addPlbAdjustment = async() => {
    const newIndex = plb_adjustments.length;
    
   await handlePlbPaginatedCurrentPage(true, plb_adjustments.length);
    triggerEobValidation([
      `plb_adjustments.${newIndex}.npi`,
      `plb_adjustments.${newIndex}.plb_page`,
      `plb_adjustments.${newIndex}.reason`,
      `plb_adjustments.${newIndex}.plb_amt`,
    ]);
  };


  // Add Adjustment
  const addAdjustment = (sfindex = null, append, adjustments_list) => {
    let id = 'claim_adjustment_id';
    let path = `claims.${activeclaim835Index}.claim_adjustments`;

    if (sfindex !== null) {
      id = 'adjustment_id';
      path = `claims.${activeclaim835Index}.service_lines.${sfindex}.adjustments`;
    }
    const newIndex = adjustments_list.length - 1;
    const editedDict = {
            "is_new":true,
            "pc": {
                "old_val": null,
                "error": true
            },
            "group_code": {
                "old_val": null,
                "error": true
            },
            "reason_code": {
                "old_val": null,
                "error": true
            },
            "rmk": {
                "old_val": null,
                "error": true
            },
            "amount": {
                "old_val": null,
                "error": true
            },
            "description": {
                "old_val": null,
                "error": true
            }
        }
    if(window.location.pathname === NEW_QA_REVIEW){editedDict.is_new = true;}

    append({
        pc: "",
        group_code: "",
        reason_code: "",
        rmk: "",
        amount: "",
        [id]: "",
        edited: true,
        ...(isQaScreen && { edited_data: editedDict })
    });    
    // handlePlbPaginatedCurrentPage(true, adjustments_list.length);
    triggerEobValidation([
      `${path}.${newIndex}.${id}`,
      `${path}.${newIndex}.pc.init_val`,
      `${path}.${newIndex}.group_code.init_val`,
      `${path}.${newIndex}.reason_code.init_val`,
      `${path}.${newIndex}.amount.init_val`
    ]);
  };

  // Render Class Helpers
  const renderClaimClass = useCallback((name, type, defaultClass) => {
    let activeclaim835Index = 0;
    const msg = eobFormErrors?.claims?.[activeclaim835Index]?.[name]?.message;

    if (msg) {
      return `${defaultClass} error-field`;
    }
    let edited_data_name = values?.claims?.[0]?.edited_data?.[name]
    let oldValue = edited_data_name?.old_val
    if((isViewScreen||isQaScreen) && oldValue !== undefined && oldValue !== values?.claims?.[0]?.[name] ){
     return defaultClass + ' qa-field'
    }

    let ediValue = edited_data_name?.edi
    if (ediValue !== undefined && ediValue != '' && ediValue === values?.claims?.[0]?.[name]) {
      return defaultClass + ' data-837'
    }
    let autoEdi = edited_data_name?.auto_edi
    if (autoEdi !== undefined && autoEdi != '' && autoEdi === values?.claims?.[0]?.[name]) {
      return defaultClass + ' automation-color automation-color-border'
    }
    let auto = edited_data_name?.auto
    if (auto !== undefined && auto != '' && auto ) {
      return defaultClass + ' automation-color'
    }

    return defaultClass;

  }, [eobFormErrors ,values]);

  const renderServiceLineClass = useCallback((name, type, defaultClass, sfindex) => {
    let activeclaim835Index = 0;
    const msg = eobFormErrors?.claims?.[activeclaim835Index]?.service_lines?.[sfindex]?.[name]?.message;

    if (msg) {
      return `${defaultClass} error-field`;
    } 
    let edited_data_name = values?.claims?.[activeclaim835Index]?.service_lines?.[sfindex]?.edited_data?.[name]
     let oldValue = edited_data_name?.old_val
    if((isViewScreen||isQaScreen) && oldValue !== undefined && oldValue !== values?.claims?.[activeclaim835Index]?.service_lines?.[sfindex]?.[name] ){
     return defaultClass + ' qa-field'
    }

    let ediValue = edited_data_name?.edi
    const currentValue = values?.claims?.[activeclaim835Index]?.service_lines?.[sfindex]?.[name];

    const normalizeValue = (val) => {
      // Try to convert to number if it's numeric
      return !isNaN(val) && val !== '' ? Number(val) : val;
    };
    if (
      ediValue !== undefined &&
      ediValue !== '' &&
      normalizeValue(ediValue) === normalizeValue(currentValue)
    ) {
      return defaultClass + ' data-837'
    }
    let autoEdi = edited_data_name?.auto_edi
    if (autoEdi !== undefined && autoEdi != '' && normalizeValue(autoEdi) === normalizeValue(values?.claims?.[activeclaim835Index]?.service_lines?.[sfindex]?.[name])) {
      return defaultClass + ' automation-color automation-color-border'
    }
    let auto = edited_data_name?.auto
    if (auto !== undefined && auto != '' && auto) {
      return defaultClass + ' automation-color'
    }


      return defaultClass;
    
  }, [eobFormErrors ,values]);


  const renderAdjustmentClass = useCallback((name, type, defaultClass, sfindex, adjIndex) => {
    let msg = null;
    let deited_data_name = ''
    let ediValue = ''
    let autoEdi = ''
    let auto = ''
    let oldValue = ''
    if (sfindex ||sfindex ===0) {
      msg = eobFormErrors?.claims?.[0]?.service_lines?.[sfindex]?.adjustments?.[adjIndex]?.[name]?.message;
      deited_data_name = values?.claims?.[0]?.service_lines?.[sfindex]?.adjustments?.[adjIndex]?.edited_data?.[name]
      ediValue = deited_data_name?.edi
      auto = deited_data_name?.auto
      autoEdi = deited_data_name?.auto_edi
      oldValue = deited_data_name?.old_val
    } else {
      msg = eobFormErrors?.claims?.[0]?.claim_adjustments?.[adjIndex]?.[name]?.message;
      deited_data_name = values?.claims?.[0]?.claim_adjustments?.[adjIndex]?.edited_data?.[name]
      ediValue = deited_data_name?.edi
      auto = deited_data_name?.auto
      autoEdi = deited_data_name?.auto_edi
      oldValue = deited_data_name?.old_val
    }
   if(msg ){
    return `${defaultClass} error-field` 
   }

  
    if((isViewScreen||isQaScreen) && oldValue !== undefined && oldValue !== values?.claims?.[0]?.service_lines?.[sfindex]?.[name] ){
     return defaultClass + ' qa-field'
    }
    
    if (ediValue !== undefined && ediValue != '' && ediValue === values?.claims?.[0]?.service_lines?.[sfindex]?.[name]) {
      return defaultClass + ' data-837'
    }
   
    if (autoEdi !== undefined && autoEdi != '' && autoEdi === values?.claims?.[0]?.service_lines?.[sfindex]?.[name]) {
      return defaultClass + '  automation-color-border'
    }
   
    if (auto !== undefined && auto != '' && auto === true ) {
      return defaultClass + ' automation-color'
    }


   return defaultClass

  }, [eobFormErrors,values ]);

  const disableCorresField = useCallback(() => { }, []);
  
  const setTransactionType = (jobdata)=>{
    const {qdx_tranansaction_type,transaction_type}=jobdata?.grid_data
    let transactionType = transaction_type
    if(transactionType === "PATIENT_PAY"){
        transactionPatientPay(transactionType)
    }
    else if(transactionType === "CORRESPONDENCE"){
        transactionCorrespondance(transactionType)
    }
    else if(transactionType === "PAYMENT835_LITE"){
        transactionPayment835Lite(transactionType)
    }else{
        transactionPayment835(transaction_type||"PAYMENT835")
    }
      // "PAYMENT835"
      // "PATIENT_PAY"
      // "PATIENT_PAY_835"
      // "CORRESPONDENCE"
      // "CORRESPONDENCE_835"
      // return "PAYMENT835"
  }
const onTransactionTypeChange = useCallback((transactionType) => { 
    if(isQdxTransactionType(transactionType)){
        transactionPayment835(transactionType)
    }
    else if(transactionType === "PATIENT_PAY"){
        transactionPatientPay(transactionType)
    }
    else if(transactionType === "CORRESPONDENCE"){
        transactionCorrespondance(transactionType)
    }
    else if(transactionType === "PAYMENT835_LITE"){
        transactionPayment835Lite(transactionType)
    }
  }, [transactionPayment835,transactionPatientPay,transactionCorrespondance,transactionPayment835Lite]);
  
  // Load jobData into form on mount/update
  useEffect(() => {
    if (jobData?.grid_data) {
      const load = async() => {
       setTransactionType(jobData)
      };
      load();
    }
  }, [jobData]);

  useEffect(()=>{
    if(values?.transaction_type&&(componentLoadingState?.isEob835&&componentLoadingState?.isGridFooter&&componentLoadingState?.isGridHeader)){
        handleChangeGridPosition()
    }
  },[values?.transaction_type,componentLoadingState,values?.grid_customization,showClaimSummary,patientLookup,payerPayeeLookup])


  window.onkeydown = function (event) {
    if ((event.key === "Enter" || event.keyCode === 13) &&
      event.ctrlKey &&
      event.shiftKey 
      ) {
   
        const result =  validateAllExceptIndex(-1,true);
      
    }
  };

  // window.onkeyup = function (event) {
  //   if ((event.key === "Enter" || event.keyCode === 13) && facilitySwal?.isSwal == true) {
  //     setFacilitySwal({ ...facilitySwal, isSwal: false })
  //   }
  //   else if (event.key == 'Tab' && event.ctrlKey && event.shiftKey ) {
  //     parent.document.getElementById('id-ctrl-tab-shift-switch').click()
  //   }
  //   else if (event.key == 'Tab' && event.ctrlKey ) {
  //     parent.document.getElementById('id-ctrl-tab-switch').click()
  //   }
  //   else if (event.altKey && event.keyCode == 78 ) {
  //     parent.document.getElementById('bottom-tab-add').click()
  //   }
  //   else if (event.altKey && event.keyCode == 88 ) {
  //     parent.document.getElementById('id-ctrl-x-remove-tab').click()
  //   }

  //   if (event.keyCode == 72 && event.altKey) {
  //     setHotKey(true);
  //     setIsDragEnabled(false)
  //   }

  //   if (event.keyCode == 89 && event.shiftKey && event.altKey && (jobData?.is_large_batch_job === false && jobData?.document_type?.patient_pay === true)) {
  //     __patientPayHandler()
  //   }

  //   if (event.keyCode == 80 && event.shiftKey && event.altKey && jobData?.document_type?.eob === true) {
  //     __payment835Handler()
  //   }
  //   if (event.keyCode == 82 && event.shiftKey && event.altKey && jobData?.document_type?.correspondence === true) {
  //     __correspondenceHandler()
  //   }
  // }

  function getNextFocusableElement(currentElement, type) {
    const gridContainer = document.getElementById("grid-full-container");
    if (type == 'tab') {
      const focusableElements = Array.from(gridContainer.querySelectorAll('[tabindex="0"]:not([data-corress-disable="true"])'));

      var currentIndex = focusableElements.indexOf(currentElement);
      if (currentIndex !== -1) {
        var nextIndex = (currentIndex + 1) % focusableElements.length;
        return focusableElements[nextIndex];
      }

    } else if (type == 'shift') {
      var inputs = Array.prototype.slice.call(gridContainer.querySelectorAll("input, select"));
      var filteredInputs = inputs.filter(function (input) {
        return !input.classList.contains("prevent-shift") && input?.getAttribute('data-corress-disable') !== "true";
      });
      const currInputIndex = filteredInputs.indexOf(currentElement);
      const input = filteredInputs[currInputIndex - 1];
      return input
    }

    return null;
  }

  function isElementInViewport(el, type) {
    if (
      (!(el.tagName === "INPUT" ||
        el.tagName === "SELECT" ||
        el.tagName === "BUTTON"))
    ) {
      return
    }
    const nextFocusInput = getNextFocusableElement(el, type)
    if (!nextFocusInput) {
     
      return false
    }
    var rect = nextFocusInput.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
     
  }


  const handleKeyUp = (event) => {
    var activeElement = document.activeElement;
    const isPlbPaginate = plbPaginatedata?.currentPage !== 1 && activeElement.getAttribute('data-plb-index') === '0'

      if (event.key == 'Tab' && !isElementInViewport(activeElement, event.shiftKey ? "shift" : "tab")) {
      const nextFocusInput = getNextFocusableElement(activeElement, event.shiftKey ? "shift" : "tab")
      if (!nextFocusInput) {
        return
      }
      var rect = nextFocusInput.getBoundingClientRect();
      if (!(rect.top >= 0) && !(rect.right <= (window.innerWidth || document.documentElement.clientWidth))) {
        let rightPosition = rect.right - window.innerWidth || document.documentElement.clientWidth
        controlledPositionRef.current = ({ ...controlledPositionRef.current, y: controlledPositionRef.current.y + Math.abs(rect.y) + 5, x: controlledPositionRef.current.x - rightPosition - 15 });
        nextFocusInput.focus()

      }
      else if (!(rect.left >= 0) && !(rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))) {
        let bottomPosition = rect.bottom - window.innerHeight || document.documentElement.clientHeight
        controlledPositionRef.current = ({ ...controlledPositionRef.current, x: controlledPositionRef.current.x - rect.x + 15, y: controlledPositionRef.current.y - bottomPosition });
        nextFocusInput.focus()

      }

      else if (!(rect.top >= 0)) {
        controlledPositionRef.current = ({ ...controlledPositionRef.current, y: controlledPositionRef.current.y + Math.abs(rect.y) + 5 });
        nextFocusInput.focus()
      }
      else if (!(rect.left >= 0)) {
        controlledPositionRef.current = ({ ...controlledPositionRef.current, x: controlledPositionRef.current.x - rect.x + 15 });
        nextFocusInput.focus()
      }
      else if (!(rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))) {
        let bottomPosition = rect.bottom - window.innerHeight || document.documentElement.clientHeight

        controlledPositionRef.current = ({ ...controlledPositionRef.current, y: controlledPositionRef.current.y - bottomPosition });
        nextFocusInput.focus()

      }
      else if (!(rect.right <= (window.innerWidth || document.documentElement.clientWidth))) {
        let rightPosition = rect.right - window.innerWidth || document.documentElement.clientWidth
        controlledPositionRef.current = ({ ...controlledPositionRef.current, x: controlledPositionRef.current.x - rightPosition - 15 });
        nextFocusInput.focus()
      }
      event.preventDefault();

      // setGridHeightPosition()
    }
    else
      if (event.key == 'Tab' && event.shiftKey && pathname == NEW_DATA_ENTRY) {
        if (!['save-exit-btn', 'save-btn'].includes(event.target.id)) {
          const currInput = document.activeElement;
          if (currInput.tagName !== "BUTTON" && currInput.type !== "checkbox" && !isPlbPaginate) {
            event.preventDefault();
            if (currInput?.getAttribute('data-prevent-shift-tab') !== "true") {
              var divElem = document.getElementById("grid-full-container");
              var inputs = Array.prototype.slice.call(divElem.querySelectorAll("input, select"));
              var filteredInputs = inputs.filter(function (input) {
                return !input.classList.contains("prevent-shift") && !input.disabled && input?.getAttribute('data-corress-disable') !== "true";
              });
              const currInputIndex = filteredInputs.indexOf(currInput);
              const input = filteredInputs[currInputIndex - 1];
              if (input) {
                if (input.type === "number" || input.type === "text") {
                  // Temporarily change the input type to "text"
                  const originalType = input.type;
                  input.type = "text";

                  // Set the cursor to the end
                  const inputLength = input.value.toString().length;
                  input.setSelectionRange(inputLength, inputLength);

                  // Revert the input type back to "number"
                  input.type = originalType;
                }
                input.focus();
                setTimeout(() => {
                  input.scrollIntoViewIfNeeded();
                }, 10)
              }
            }
          } else if (isPlbPaginate) {
            handlePlbPageChange(plbPaginatedata?.currentPage - 1)
            setTimeout(() => {
              const plbContainer = document.querySelector('.plb-main-component-container');
              const inputs = plbContainer?.querySelectorAll('input');
              if (inputs && inputs.length > 0) {
                const lastInput = inputs[inputs.length - 1]; // Get the last input
                lastInput.focus()
              }

            }, 10)
          }
        }
      } else if (event.key == 'Tab' && event.shiftKey && isPlbPaginate) {
        handlePlbPageChange(plbPaginatedata?.currentPage - 1)
        setTimeout(() => {
          const plbContainer = document.querySelector('.plb-main-component-container');
          const inputs = plbContainer?.querySelectorAll('input');
          if (inputs && inputs.length > 0) {
            const lastInput = inputs[inputs.length - 1]; // Get the last input
            lastInput.focus()
          }

        }, 10)
      }

  };



    useEffect(() => {
    if (patientLookup) return; // Don't add listener if patientLookup is true

    

    window.addEventListener("keydown", handleKeyUp);

    return () => {
        window.removeEventListener("keydown", handleKeyUp);
    };
    }, [patientLookup,plbPaginatedata]);



    const onPlbRangeChange = useCallback(async (page,type=null,limit=15) => {
    const values = eobFormGetValues()
  try {
    const {
      plb_order=1,
      plb_db_order = "",
      del_plb = [],
      plb_next_id = null,
      plb_prev_id = null,
      transaction_type = "PAYMENT835",
      is_plb_clear_all,
    } = values || {};
          const plb_adjustments = values?.plb_adjustments
          const plb_adjustments1 = processEditedPlbAdjustments(plb_adjustments,plb_order)
          const plbParams = {
            work_type: getTaskType(),
            transaction_type: transaction_type || "PAYMENT835",
            job: jobData?.job,
            plbs: plb_adjustments1,
            del_plb,
            plb_db_order,
            initial_id: type === "next" ? plb_next_id : type === "previous" ? plb_prev_id : type,
            limit,
            page,
            is_clear_all:is_plb_clear_all
        };

      const fetchData = await getPlbDetailsFromNewGrid(plbParams);
    
    if (fetchData?.status_code === 400) {
      const errors = fetchData?.errors || {};
      const messages = Object.entries(errors)
        .map(([field, msgs]) => `${field}: ${msgs.join(", ")}`)
        .join("\n");
        showAlert('general', 'Validation Error', messages);

      return false; // Indicate failure
    } else {
      const changedPlbData = processPlbAdjustments(fetchData?.data?.plb_adjustments);

      // setPagenateInputVal(plb_adjustments[0]?.order);
      // setFullClaimData(plb_adjustments);
      eobFormSetValues('del_plb', [], { shouldDirty: false });
      eobFormSetValues('plb_adjustments', changedPlbData, { shouldDirty: true });
      eobFormSetValues('plb_next_id', fetchData?.data?.plb_next_id || null, { shouldDirty: true });
      eobFormSetValues('plb_prev_id', fetchData?.data?.plb_prev_id || null, { shouldDirty: true });
      eobFormSetValues('total_plb_amt', fetchData?.data?.total_plb_amt || 0, { shouldDirty: true });
      eobFormSetValues('total_plb', fetchData?.data?.total_plb, { shouldDirty: true });
      eobFormSetValues('plb_db_order', fetchData?.data?.plb_db_order, { shouldDirty: true });
      eobFormSetValues('plb_order', changedPlbData[0]?.order, { shouldDirty: true });
      eobFormSetValues('is_plb_clear_all', false);
      setPlbPage(page)
      await triggerEobValidation('plb_adjustments');
      return true; // Indicate success
    }
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
}, [,jobData, eobFormSetValues,eobFormGetValues,processPlbAdjustments,processEditedPlbAdjustments]);


  // PLB Pagination
    const handlePlbPageChange = useCallback(async (pageNumber,type,limit=15) => {
    const total_plb = eobFormGetValues('total_plb')||0
    const totalPages = Math.ceil(total_plb / 15) || 1;
    if (pageNumber < 1 || pageNumber > totalPages) {
        return;
    }
    
    await onPlbRangeChange(pageNumber,type);
    }, [eobFormGetValues,onPlbRangeChange]);

const handlePlbPaginatedCurrentPage = useCallback(async(shouldDecrement) => {
    const totalItems = eobFormGetValues('total_plb')||0
    const currentPage = plbPage
    const totalPages = Math.ceil(totalItems / 15) || 1;
    const isCurrentPageHave15 = totalItems !==0 ? (totalItems % 15)===0 : false
    setisPlbPaginateLoading(true)
    if(isCurrentPageHave15)
    {
        await onPlbRangeChange(totalPages+1);
        setPlbPage(totalPages+1)
        eobFormSetValues('total_plb',totalItems+1)
        eobFormSetValues('plb_order', totalItems+1, { shouldDirty: true });
        eobFormSetValues('plb_adjustments', [], { shouldDirty: true });
        appendPlbAdjustment(getEmptyPlbAdjustment);
        triggerEobValidation('plb_adjustments');
    }
    else if(!(currentPage === totalPages))
    {
        if(!(totalPages===1)){
            await onPlbRangeChange(totalPages); 
        }
        eobFormSetValues('total_plb',totalItems+1)
        appendPlbAdjustment(getEmptyPlbAdjustment);
    }
     else {
        eobFormSetValues('total_plb',totalItems+1)
        appendPlbAdjustment(getEmptyPlbAdjustment);
    }
    setisPlbPaginateLoading(false)
     

}, [plbPage, handlePlbPageChange,appendPlbAdjustment,triggerEobValidation]);

const removePlbAdjustment = async (index) => {
    const total_plb = eobFormGetValues('total_plb')||0
    const currentPlbAdj = eobFormGetValues('plb_adjustments')
    let currentplbPage = plbPage
    const totalPages = Math.ceil(total_plb / 15) || 1;
    deletePlbAdjustment(index)
  try {
    if(currentPlbAdj?.length ===1){
        setisPlbPaginateLoading(true)
        if((plbPage === totalPages)){
            currentplbPage = currentplbPage-1
            //laast page
        }else if(plbPage === 1&& total_plb > 1){
            currentplbPage = 1
            //first page with next page
            
        }else if(plbPage===1 && total_plb===1){
            currentplbPage = 1
            //onlly one page
        }
        setPlbPage(currentplbPage||1)

        await onPlbRangeChange(currentplbPage);
        setisPlbPaginateLoading(false)

    }else if(totalPages===1 && total_plb>=1){
            eobFormSetValues('total_plb',total_plb-1,{ shouldDirty: true })
        }
    // Recalculate total items
    // const newTotal = total_plb - 1;
    // eobFormSetValues('total_plb',newTotal)
    
    // Refresh current page or navigate to previous page if needed
    // handlePlbPaginatedCurrentPage(true, newTotal);
    
  } catch (error) {
    console.error('Error deleting PLB adjustment:', error);
    // Optionally show error toast/notification
  }
};

  // Reset Grid
  const resetGrid = useCallback((type = "all") => {
    const load = async () => {
      if (type === "claims" || (contextValues?.isSubJob&&!contextValues?.isFirstJob)) {
        eobFormSetValues('claims', initialClaim, { shouldDirty: true });
        eobFormSetValues('plb_adjustments', [], { shouldDirty: true });
        setFullClaimData(initialClaim);
        await triggerEobValidation('claims');
      } else {
        const data = {
            ...initialGridData,
            is_plb_clear_all: true,
            is_claim_clear_all: true,
            transaction_type:values?.transaction_type,
            grid_customization:values?.grid_customization,
            is_valid_tax_identification_number: false,
            is_valid_payee_npi: false,

        }
        loadEobFormdata(data);
        setStartClaimOrder(1);
        setPagenateInputVal(1);
        setActiveclaim835Index(0);
        setFullClaimData(initialGridData?.claims);
        setFullClaimTotal([])
        await triggerEobValidation();
      }
      setPlbPage(1);
    };
    load();
  }, [loadEobFormdata, triggerEobValidation,values,contextValues]);

  // Move Claim
  const __moveClaim = useCallback((type) => {
    if (moveClaimIndex == null || moveClaimIndex < 0) return;

    const isFirst = moveClaimIndex === 0;
    const isLast = moveClaimIndex === claimsData.length - 1;

    let newIndex = moveClaimIndex;

    if (type === 'UP' && !isFirst) {
      newIndex = moveClaimIndex - 1;
      moveClaim(moveClaimIndex, newIndex);
      setMoveClaimIndex(newIndex);
    } else if (type === 'DOWN' && !isLast) {
      newIndex = moveClaimIndex + 1;
      moveClaim(moveClaimIndex, newIndex);
      setMoveClaimIndex(newIndex);
    } else {
      return;
    }

    setTimeout(() => {
      const element = document.getElementById(`claim-summary-ind${newIndex}`);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }
    }, 100);
  }, [moveClaimIndex, moveClaim, claimsData.length, setMoveClaimIndex]);

  // Assign/Reject Handlers
  const handleSingleAssign = useCallback((value) => {
    setGridFormLoader(true)
    loadNextJob()
    const final_data = {
      job: jobData?.job,
      reason: values?.assign_reason,
      user: assignTo === "user",
      is_sub_job_reassign: false,
      data: [],
    };
    assignJobFromQaV2(final_data)((response) => {
      if (response?.status) {
        setGridFormLoader(false)
        setAssignTooltip(false)
        // deleteIndexedData('grid_data_cache');
        // deleteIndexedData('visited_pages')
        if(jobData?.job){
            checkUserPermissions();  
        }
    }
      else if (response?.status_code === 400 && response?.errors?.reassign_user?.length > 0) {setGridFormLoader(false);setAssignTooltip(false)};
    });
  }, [assignTo, jobData, values,loadNextJob]);

  const handleMultipleAssign = useCallback((value) => {
    const valuesss = [];
    value?.data?.map((value) => {
      if (value.is_select) {
        valuesss.push({
          user: value?.assignTo === "user",
          reason: value?.assign_reason || "",
          sub_job: value?.value || "",
        });
      }
    });
    const final_data = {
      job: jobData?.job,
      reason: "",
      user: "",
      is_sub_job_reassign: true,
      data: valuesss,
    };
    if (valuesss.length > 0) loadNextJob();
    setGridFormLoader(true)
    assignJobFromQaV2(final_data)((response) => {
      if (response?.status) {
        setGridFormLoader(false)
        setAssignTooltip(false);

        // deleteIndexedData('grid_data_cache');
        // deleteIndexedData('visited_pages')
        if(jobData?.job){
            checkUserPermissions();  
        }
        
    }
      else if (response?.status_code === 400 && response?.errors?.reassign_user?.length > 0) {setGridFormLoader(false);setAssignTooltip(false)};
    });
  }, [jobData, values,loadNextJob]);

  const handleRejectSubmit = useCallback((value) => {
      
    const user = JSON.parse(localStorage.getItem("user"));
    const user_id = user?.id;
    const job = jobData?.job;
    const qdx_reasons = values?.qdx_reason.length > 0 ? values?.qdx_reason : [];
    setGridFormLoader(true)
    loadNextJob()  
    rejectFile(
      job,
      rejectPopupState.rejection_reason,
      user_id,
      value.message,
      qdx_reasons
    )(async (response) => {
        if (response?.status) {
            setGridFormLoader(false)
            // deleteIndexedData('grid_data_cache');
            // deleteIndexedData('visited_pages')
            if(jobData?.job){
                const hasPermission = await checkUserPermissions();  
            }
        }
        else if (response?.status_code == 400 && response?.errors && response?.errors?.rejection_user?.length > 0) {
                showAlert("error",null,response?.errors?.rejection_user[0])
                setGridFormLoader(false)
        }else{
            showAlert("error",null,'ERROR WHILE SAVING PREVIOUS JOB',{is_errorJob:true})
            setGridFormLoader(false)
        }
     });
  }, [jobData, values, rejectPopupState]);

  // Claim Range Change
const onClaimRangeChange = useCallback(async ({ from = null, to = null, limit, type = null,setRangeFrom=null,setRangeTo=null }) => {
  try {
    const {
      claims = [],
      db_order = "",
      del_clm = [],
      del_sl = [],
      del_adjust_sl = [],
      del_adjust_clm = [],
      next_id = null,
      prev_id = null,
      transaction_type = "PAYMENT835",
      is_claim_clear_all=false
    } = values || {};
    handleQaErrorCheck('save_or_next_or_copy')
    const updatedFullClaims = updateClaimAtIndex(fullclaimData, activeclaim835Index, claims[0]);
    const updated_claims = processEditedClaimsUltraFast(updatedFullClaims, startClaimOrder);


      const fetchData = await getClaimDetailsFromNewGrid({
      work_type: getTaskType(),
      db_order,
      transaction_type: transaction_type||"PAYEMENT835",
      job: jobData?.job,
      // Only pass from and to for a custom range
      claim_from: type === "custom_range" ? from : null,
      claim_to: type === "custom_range" ? to : null,
      // Pass the limit for all operations
      limit: limit,
      initial_id: type === "next" ? next_id : type === "previous" ? prev_id : type,
      claims: updated_claims,
      del_clm,
      del_sl,
      del_adjust_sl,
      del_adjust_clm,
      is_clear_all:is_claim_clear_all
    });
    
    if (fetchData?.status_code === 400) {
      const errors = fetchData?.errors || {};
      const messages = Object.entries(errors)
        .map(([field, msgs]) => `${field}: ${msgs.join(", ")}`)
        .join("\n");
        showAlert('general', 'Validation Error', messages);

      return false; // Indicate failure
    } else {
      const isPullDataNeed = jobData?.grid_data?.transaction_type !== "PATIENT_PAY_835";
      const claims1 = processClaimsAutomation({ ...values, claims: fetchData?.data?.claims }, transaction_type, isPullDataNeed)?.claims || [];
      if(setRangeFrom && setRangeTo){
        setRangeFrom(claims1[0]?.order)
        setRangeTo(claims1[0]?.order+(claims1?.length-1))
      }
      setStartClaimOrder(claims1[0]?.order);
      setPagenateInputVal(claims1[0]?.order);
      setActiveclaim835Index(0);
      setFullClaimData(claims1);
      eobFormSetValues('claims', [claims1[0]], { shouldDirty: true });
      eobFormSetValues('next_id', fetchData?.data?.next_id || null, { shouldDirty: true });
      eobFormSetValues('prev_id', fetchData?.data?.prev_id || null, { shouldDirty: true });
      setFullClaimTotal(fetchData?.data?.claims_total_amounts||[]);
      eobFormSetValues('total_claims', fetchData?.data?.total_claims, { shouldDirty: true });
      eobFormSetValues('del_clm', [], { shouldDirty: true });
      eobFormSetValues('del_sl', [], { shouldDirty: true });
      eobFormSetValues('del_adjust_sl', [], { shouldDirty: true });
      eobFormSetValues('del_adjust_clm', [], { shouldDirty: true });
      eobFormSetValues('db_order', fetchData?.data?.db_order, { shouldDirty: true });
      eobFormSetValues('is_claim_clear_all', false, { shouldDirty: true });
      await triggerEobValidation('claims');
      return true; // Indicate success
    }
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
}, [handleQaErrorCheck,values, jobData, eobFormSetValues, fullclaimData, startClaimOrder, activeclaim835Index]);


const onClaimLogRangeChange = useCallback(async ({ from = null, to = null, limit,page, type = null,setRangeFrom=null,setRangeTo=null }) => {
  try {
    const fetchData = await getAllLogDetails({ data_type:"4",job_log, page, limit,from,to,is_view_history:log_id?true:false });
    const {claims} = fetchData?.data
    // Return all data
    if (fetchData?.status_code === 400) {
      const errors = fetchData?.errors || {};
      const messages = Object.entries(errors)
        .map(([field, msgs]) => `${field}: ${msgs.join(", ")}`)
        .join("\n");
        showAlert('general', 'Validation Error', messages);

      return false; // Indicate failure
    } else {
      if(setRangeFrom && setRangeTo){
        setRangeFrom(claims[0]?.order)
        setRangeTo(claims[0]?.order+(claims?.length-1))
      }
      setStartClaimOrder(claims[0]?.order);
      setPagenateInputVal(claims[0]?.order);
      setActiveclaim835Index(0);
      setFullClaimData(claims);
      eobFormSetValues('claims', [claims[0]], { shouldDirty: false });
      return true; // Indicate success
    }
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
}, [jobData, eobFormSetValues, startClaimOrder, activeclaim835Index,job_log]);

const onPlbLogRangeChange = useCallback(async (page,type=null,limit=15) => {
  try {
    const fetchData = await getAllLogDetails({ data_type:"3",job_log, page, limit,is_view_history:log_id?true:false });
    
    if (fetchData?.status_code === 400) {
      const errors = fetchData?.errors || {};
      const messages = Object.entries(errors)
        .map(([field, msgs]) => `${field}: ${msgs.join(", ")}`)
        .join("\n");
        showAlert('general', 'Validation Error', messages);

      return false; // Indicate failure
    } else {
      const changedPlbData = processPlbAdjustments(fetchData?.data?.plb_adjustments);

      // setPagenateInputVal(plb_adjustments[0]?.order);
      // setFullClaimData(plb_adjustments);
      eobFormSetValues('del_plb', [], { shouldDirty: false });
      eobFormSetValues('plb_adjustments', changedPlbData, { shouldDirty: true });
      eobFormSetValues('plb_next_id', fetchData?.data?.plb_next_id || null, { shouldDirty: true });
      eobFormSetValues('plb_prev_id', fetchData?.data?.plb_prev_id || null, { shouldDirty: true });
      eobFormSetValues('total_plb_amt', fetchData?.data?.total_plb_amt || 0, { shouldDirty: true });
      eobFormSetValues('total_plb', fetchData?.data?.total_plb, { shouldDirty: true });
      eobFormSetValues('plb_db_order', fetchData?.data?.plb_db_order, { shouldDirty: true });
      eobFormSetValues('plb_order', changedPlbData[0]?.order, { shouldDirty: true });
      setPlbPage(page)
      await triggerEobValidation('plb_adjustments');
      return true; // Indicate success
    }
  } catch (error) {
    console.error('Error:', error);
    return false;
  }
}, [,jobData, eobFormSetValues,eobFormGetValues,processPlbAdjustments,processEditedPlbAdjustments]);


const goToIndex = useCallback(async (newIndex) => {
    if (newIndex < 0 || newIndex >= fullclaimData.length) return;

    //  const result = await validateAllExceptIndex(newIndex);
    const updatedClaim = updateClaimAtIndex(fullclaimData, activeclaim835Index, values?.claims[0]);
    setFullClaimData(updatedClaim)

    setActiveclaim835Index(newIndex); //------------------
    eobFormSetValues('claims', [updatedClaim[newIndex]], { shouldDirty: false, shouldValidate: false });
    triggerEobValidation('claims.0');
    setPagenateInputVal(startClaimOrder + newIndex);
    setActiveserviceLineIndex(0); //----------------------

  }, [setFullClaimData,values,activeclaim835Index,
     setActiveclaim835Index, eobFormSetValues, clearErrors, triggerEobValidation,
      setPagenateInputVal, setActiveserviceLineIndex, startClaimOrder, fullclaimData ]);

const validateAllExceptIndex = useCallback((index = -1,isNavigate) => {
  const values = eobFormGetValues()
  if(Object.keys(values).length===0 || (values?.qdx_status === "INCOMPLETE" || values?.grid_customization === "PLB_ONLY"))return true
  const isQdaxTran = isQdxTransactionType(values?.transaction_type)
  if (!(isQdaxTran||values?.transaction_type!=="PAYMENT835_LITE")) return true;
  const indexToSkip = index === -1 ? activeclaim835Index : index;
    let validateClaimWise = isQdaxTran?validateClaimOneByOne:values?.transaction_type==="PAYMENT835_LITE"?validateClaimLiteOneByOne:validateClaimCorresOneByOne
  const fullData = fullclaimData;


  for (let i = 0; i < fullData.length; i++) {

    const claimToValidate = (i === indexToSkip)
      ? values?.claims[0]
      : fullData[i];

    const result = validateClaimWise(claimToValidate, values, contextValues);
    if (Object.keys(result).length > 0) {
      if(isNavigate){
          document.activeElement.blur();
          setTimeout(() => goToIndex(i), 1);
      }
      return false // stop loop immediately
    }
  }

  return true;
}, [validateClaimOneByOne,validateClaimLiteOneByOne,validateClaimCorresOneByOne,activeclaim835Index,eobFormGetValues,fullclaimData]);


const handleChangeSLCalculation = useCallback((e, sfindex, type, adj) => {
    const value = e.target.value;
    // if(type==="billed"){debugger}

    // Get current form values
    const index = 0
    
    let oldval = 0;
    let old_claim = 0;
    const claims = eobFormGetValues('claims')
    const currentValues = claims?.length > 0?claims[0]:{}
    let old_balance = currentValues?.service_lines?.[sfindex]?.balance || 0;
    
    if (type === 'amount') {
        oldval = currentValues?.service_lines?.[sfindex]?.adjustments?.[adj]?.amount || 0;
    } else {
        oldval = currentValues?.service_lines?.[sfindex]?.[type] || 0;
    }

    // Set the original field value
    const changedValue = (value||value===0)?parseFloat(value).toFixed(2) :""
    if (type === 'amount') {
        eobFormSetValues(`claims.${index}.service_lines.${sfindex}.adjustments.${adj}.amount`, changedValue,{ shouldValidate: false, shouldDirty: false });
        customFieldValidator([`claims.${index}.service_lines.${sfindex}.adjustments.${adj}.group_code`]);
    } else {
        eobFormSetValues(`claims.${index}.service_lines.${sfindex}.${type}`, changedValue,{ shouldValidate: false, shouldDirty: false });
    }

    switch (type) {
        case "billed":
            old_claim = currentValues?.claim_billed || 0;
            
            const slBilledValue = parseFloat((parseFloat(currentValues?.sl_billed || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_billed`, slBilledValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_billed`, slBilledValue,{ shouldValidate: false, shouldDirty: false });

            const rowBalanceValue = parseFloat((parseFloat(old_balance || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            const finalRowBalance = rowBalanceValue === '-0.00' ? '0.00' : rowBalanceValue;
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalRowBalance,{ shouldValidate: false, shouldDirty: false });

            const slTotalValue = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, slTotalValue,{ shouldValidate: false, shouldDirty: false });

            const clTotalValue = parseFloat((parseFloat(slBilledValue || 0)) -
                (parseFloat(currentValues?.claim_discount || 0) +
                    parseFloat(currentValues?.claim_patres || 0) +
                    parseFloat(currentValues?.claim_cob || 0) +
                    parseFloat(currentValues?.claim_paid || 0) +
                    parseFloat(parseFloat(currentValues?.sl_amount || 0) - parseFloat(parseFloat(currentValues?.sl_patres || 0) - parseFloat(parseFloat(currentValues?.sl_deduct || 0) + parseFloat(currentValues?.sl_coins || 0) + parseFloat(currentValues?.sl_copay || 0)))) +
                    parseFloat(parseFloat(currentValues?.claim_adjustment_total || 0) - parseFloat(currentValues?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, clTotalValue,{ shouldValidate: false, shouldDirty: false });
            break;

        case "discount":
            old_claim = currentValues?.claim_discount || 0;

            const slDiscountValue = parseFloat((parseFloat(currentValues?.sl_discount || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_discount`, slDiscountValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_discount`, slDiscountValue,{ shouldValidate: false, shouldDirty: false });

            const discountRowBalance = parseFloat((parseFloat(old_balance || 0) + parseFloat(oldval || 0)) - parseFloat(value || 0)).toFixed(2);
            const finalDiscountRowBalance = discountRowBalance === '-0.00' ? '0.00' : discountRowBalance;
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalDiscountRowBalance,{ shouldValidate: false, shouldDirty: false });

            const discountSlTotal = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalDiscountRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, discountSlTotal,{ shouldValidate: false, shouldDirty: false });

            const discountClTotal = parseFloat((parseFloat(currentValues?.claim_billed || 0)) -
                (parseFloat(slDiscountValue || 0) +
                    parseFloat(currentValues?.claim_patres || 0) +
                    parseFloat(currentValues?.claim_cob || 0) +
                    parseFloat(currentValues?.claim_paid || 0) +
                    parseFloat(parseFloat(currentValues?.sl_amount || 0) - parseFloat(parseFloat(currentValues?.sl_patres || 0) - parseFloat(parseFloat(currentValues?.sl_deduct || 0) + parseFloat(currentValues?.sl_coins || 0) + parseFloat(currentValues?.sl_copay || 0)))) +
                    parseFloat(parseFloat(currentValues?.claim_adjustment_total || 0) - parseFloat(currentValues?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, discountClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "allowed":
            const slAllowedValue = parseFloat((parseFloat(currentValues?.sl_allowed || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_allowed`, slAllowedValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_allowed`, slAllowedValue,{ shouldValidate: false, shouldDirty: false });
            break;

        case "deduct":
            old_claim = currentValues?.claim_deduct || 0;

            const slDeductValue = parseFloat((parseFloat(currentValues?.sl_deduct || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_deduct`, slDeductValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_deduct`, slDeductValue,{ shouldValidate: false, shouldDirty: false });

            const deductRowBalance = parseFloat((parseFloat(old_balance || 0) + parseFloat(oldval || 0)) - parseFloat(value || 0)).toFixed(2);
            const finalDeductRowBalance = deductRowBalance === '-0.00' ? '0.00' : deductRowBalance;
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalDeductRowBalance,{ shouldValidate: false, shouldDirty: false });

            const deductSlTotal = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalDeductRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, deductSlTotal,{ shouldValidate: false, shouldDirty: false });

            const deductPatres = parseFloat((parseFloat(currentValues?.sl_patres || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_patres`, deductPatres,{ shouldValidate: false, shouldDirty: false });

            const deductClPatres = parseFloat((parseFloat(deductPatres || 0) +
                parseFloat(currentValues?.claim_adjustment_total_pr || 0) +
                parseFloat(parseFloat(slDeductValue || 0) != parseFloat(slDeductValue || 0) ? parseFloat(slDeductValue || 0) : parseFloat(0)) +
                parseFloat(parseFloat(currentValues?.sl_coins || 0) != parseFloat(currentValues?.claim_coins || 0) ? parseFloat(currentValues?.claim_coins || 0) : parseFloat(0)) +
                parseFloat(parseFloat(currentValues?.sl_copay || 0) != parseFloat(currentValues?.claim_copay || 0) ? parseFloat(currentValues?.claim_copay || 0) : parseFloat(0))
            )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_patres`, deductClPatres,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.fake_sl_patres`, deductClPatres,{ shouldValidate: false, shouldDirty: false });

            const deductClTotal = parseFloat((parseFloat(currentValues?.claim_billed || 0)) -
                (parseFloat(currentValues?.claim_discount || 0) +
                    parseFloat(deductClPatres || 0) +
                    parseFloat(currentValues?.claim_cob || 0) +
                    parseFloat(currentValues?.claim_paid || 0) +
                    parseFloat(parseFloat(currentValues?.sl_amount || 0) - parseFloat(parseFloat(deductPatres || 0) - parseFloat(parseFloat(slDeductValue || 0) + parseFloat(currentValues?.sl_coins || 0) + parseFloat(currentValues?.sl_copay || 0)))) +
                    parseFloat(parseFloat(currentValues?.claim_adjustment_total || 0) - parseFloat(currentValues?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, deductClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "coins":
            old_claim = currentValues?.claim_coins || 0;

            const slCoinsValue = parseFloat((parseFloat(currentValues?.sl_coins || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_coins`, slCoinsValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_coins`, slCoinsValue,{ shouldValidate: false, shouldDirty: false });

            const coinsRowBalance = parseFloat((parseFloat(old_balance || 0) + parseFloat(oldval || 0)) - parseFloat(value || 0)).toFixed(2);
            const finalCoinsRowBalance = coinsRowBalance === '-0.00' ? '0.00' : coinsRowBalance;
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalCoinsRowBalance,{ shouldValidate: false, shouldDirty: false });

            const coinsSlTotal = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalCoinsRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, coinsSlTotal,{ shouldValidate: false, shouldDirty: false });

            const coinsPatres = parseFloat((parseFloat(currentValues?.sl_patres || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_patres`, coinsPatres,{ shouldValidate: false, shouldDirty: false });

            const coinsClPatres = parseFloat((parseFloat(coinsPatres || 0) +
                parseFloat(currentValues?.claim_adjustment_total_pr || 0) +
                parseFloat(parseFloat(slCoinsValue || 0) != parseFloat(slCoinsValue || 0) ? parseFloat(slCoinsValue || 0) : parseFloat(0)) +
                parseFloat(parseFloat(currentValues?.sl_deduct || 0) != parseFloat(currentValues?.claim_deduct || 0) ? parseFloat(currentValues?.claim_deduct || 0) : parseFloat(0)) +
                parseFloat(parseFloat(currentValues?.sl_copay || 0) != parseFloat(currentValues?.claim_copay || 0) ? parseFloat(currentValues?.claim_copay || 0) : parseFloat(0))
            )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_patres`, coinsClPatres,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.fake_sl_patres`, coinsClPatres,{ shouldValidate: false, shouldDirty: false });

            const coinsClTotal = parseFloat((parseFloat(currentValues?.claim_billed || 0)) -
                (parseFloat(currentValues?.claim_discount || 0) +
                    parseFloat(coinsClPatres || 0) +
                    parseFloat(currentValues?.claim_cob || 0) +
                    parseFloat(currentValues?.claim_paid || 0) +
                    parseFloat(parseFloat(currentValues?.sl_amount || 0) - parseFloat(parseFloat(coinsPatres || 0) - parseFloat(parseFloat(currentValues?.sl_deduct || 0) + parseFloat(slCoinsValue || 0) + parseFloat(currentValues?.sl_copay || 0)))) +
                    parseFloat(parseFloat(currentValues?.claim_adjustment_total || 0) - parseFloat(currentValues?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, coinsClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "copay":
            old_claim = currentValues?.claim_copay || 0;

            const slCopayValue = parseFloat((parseFloat(currentValues?.sl_copay || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_copay`, slCopayValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_copay`, slCopayValue,{ shouldValidate: false, shouldDirty: false });

            const copayRowBalance = parseFloat((parseFloat(old_balance || 0) + parseFloat(oldval || 0)) - parseFloat(value || 0)).toFixed(2);
            const finalCopayRowBalance = copayRowBalance === '-0.00' ? '0.00' : copayRowBalance;
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalCopayRowBalance,{ shouldValidate: false, shouldDirty: false });

            const copaySlTotal = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalCopayRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, copaySlTotal,{ shouldValidate: false, shouldDirty: false });

            const copayPatres = parseFloat((parseFloat(currentValues?.sl_patres || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_patres`, copayPatres,{ shouldValidate: false, shouldDirty: false });

            const copayClPatres = parseFloat((parseFloat(copayPatres || 0) +
                parseFloat(currentValues?.claim_adjustment_total_pr || 0) +
                parseFloat(parseFloat(slCopayValue || 0) != parseFloat(slCopayValue || 0) ? parseFloat(slCopayValue || 0) : parseFloat(0)) +
                parseFloat(parseFloat(currentValues?.sl_deduct || 0) != parseFloat(currentValues?.claim_deduct || 0) ? parseFloat(currentValues?.claim_deduct || 0) : parseFloat(0)) +
                parseFloat(parseFloat(currentValues?.sl_coins || 0) != parseFloat(currentValues?.claim_coins || 0) ? parseFloat(currentValues?.claim_coins || 0) : parseFloat(0))
            )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_patres`, copayClPatres,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.fake_sl_patres`, copayClPatres,{ shouldValidate: false, shouldDirty: false });

            const copayClTotal = parseFloat((parseFloat(currentValues?.claim_billed || 0)) -
                (parseFloat(currentValues?.claim_discount || 0) +
                    parseFloat(copayClPatres || 0) +
                    parseFloat(currentValues?.claim_cob || 0) +
                    parseFloat(currentValues?.claim_paid || 0) +
                    parseFloat(parseFloat(currentValues?.sl_amount || 0) - parseFloat(parseFloat(copayPatres || 0) - parseFloat(parseFloat(currentValues?.sl_deduct || 0) + parseFloat(currentValues?.sl_coins || 0) + parseFloat(slCopayValue || 0)))) +
                    parseFloat(parseFloat(currentValues?.claim_adjustment_total || 0) - parseFloat(currentValues?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, copayClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "cob":
            old_claim = currentValues?.claim_cob || 0;

            const slCobValue = parseFloat((parseFloat(currentValues?.sl_cob || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_cob`, slCobValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_cob`, slCobValue,{ shouldValidate: false, shouldDirty: false });

            const cobRowBalance = parseFloat((parseFloat(old_balance || 0) + parseFloat(oldval || 0)) - parseFloat(value || 0)).toFixed(2);
            const finalCobRowBalance = cobRowBalance === '-0.00' ? '0.00' : cobRowBalance;
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalCobRowBalance,{ shouldValidate: false, shouldDirty: false });

            const cobSlTotal = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalCobRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, cobSlTotal,{ shouldValidate: false, shouldDirty: false });

            const cobClTotal = parseFloat((parseFloat(currentValues?.claim_billed || 0)) -
                (parseFloat(currentValues?.claim_discount || 0) +
                    parseFloat(currentValues?.claim_patres || 0) +
                    parseFloat(slCobValue || 0) +
                    parseFloat(currentValues?.claim_paid || 0) +
                    parseFloat(parseFloat(currentValues?.sl_amount || 0) - parseFloat(parseFloat(currentValues?.sl_patres || 0) - parseFloat(parseFloat(currentValues?.sl_deduct || 0) + parseFloat(currentValues?.sl_coins || 0) + parseFloat(currentValues?.sl_copay || 0)))) +
                    parseFloat(parseFloat(currentValues?.claim_adjustment_total || 0) - parseFloat(currentValues?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, cobClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "paid":
            old_claim = currentValues?.claim_paid || 0;

            const slPaidValue = parseFloat((parseFloat(currentValues?.sl_paid || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_paid`, slPaidValue,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${index}.claim_paid`, slPaidValue,{ shouldValidate: false, shouldDirty: false });
            
            const paidRowBalance = parseFloat((parseFloat(old_balance || 0) + parseFloat(oldval || 0)) - parseFloat(value || 0)).toFixed(2);
            const finalPaidRowBalance = paidRowBalance === '-0.00' ? '0.00' : paidRowBalance;
            // if(changedValue !== ''){
            // }
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalPaidRowBalance,{ shouldValidate: false, shouldDirty: false });

            const paidSlTotal = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalPaidRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, paidSlTotal,{ shouldValidate: false, shouldDirty: false });

            const paidClTotal = parseFloat((parseFloat(currentValues?.claim_billed || 0)) -
                (parseFloat(currentValues?.claim_discount || 0) +
                    parseFloat(currentValues?.claim_patres || 0) +
                    parseFloat(currentValues?.claim_cob || 0) +
                    parseFloat(slPaidValue || 0) +
                    parseFloat(parseFloat(currentValues?.sl_amount || 0) - parseFloat(parseFloat(currentValues?.sl_patres || 0) - parseFloat(parseFloat(currentValues?.sl_deduct || 0) + parseFloat(currentValues?.sl_coins || 0) + parseFloat(currentValues?.sl_copay || 0)))) +
                    parseFloat(parseFloat(currentValues?.claim_adjustment_total || 0) - parseFloat(currentValues?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, paidClTotal,{ shouldValidate: false, shouldDirty: false });
            
            const check_amount = eobFormGetValues('check_amount')
            const total_plb_amt = eobFormGetValues('total_plb_amt')||0

            const updatedArray = manipulateTotalClaimPaidArray(fullclaimTotal?.current, (startClaimOrder+activeclaim835Index)-1, "update",{id:currentValues?.claim_id||null,paid_amount:slPaidValue});
            // Calculate paid total and remaining balance
            const { remaining } = calculateRemainingPlbPaidTotals(updatedArray,total_plb_amt, check_amount,'paid_amount');
            
            eobFormSetValues('remaining_balance', remaining,{ shouldValidate: false, shouldDirty: false });
            setFullClaimTotal(updatedArray);
            
            break;

        case "amount":
            old_claim = currentValues?.sl_amount || 0;
            
            const slAmountValue = parseFloat((parseFloat(currentValues?.sl_amount || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_amount`, slAmountValue,{ shouldValidate: false, shouldDirty: false });

            const amountRowBalance = parseFloat((parseFloat(old_balance || 0) + parseFloat(oldval || 0)) - parseFloat(value || 0)).toFixed(2);
            const finalAmountRowBalance = amountRowBalance === '-0.00' ? '0.00' : amountRowBalance;
            eobFormSetValues(`claims.${index}.service_lines.${sfindex}.balance`, finalAmountRowBalance,{ shouldValidate: false, shouldDirty: false });

            const amountSlTotal = parseFloat((parseFloat(currentValues?.sl_balance || 0) - parseFloat(old_balance || 0)) + parseFloat(finalAmountRowBalance || 0)).toFixed(2);
            eobFormSetValues(`claims.${index}.sl_balance`, amountSlTotal,{ shouldValidate: false, shouldDirty: false });

            // Handle PR adjustments
            if (currentValues?.service_lines?.[sfindex]?.adjustments?.[adj]?.group_code === 'PR') {
                const amountPatres = parseFloat((parseFloat(currentValues?.sl_patres || 0) - parseFloat(oldval || 0)) + parseFloat(value || 0)).toFixed(2);
                eobFormSetValues(`claims.${index}.sl_patres`, amountPatres,{ shouldValidate: false, shouldDirty: false });

                const amountClPatres = parseFloat((parseFloat(amountPatres || 0) +
                    parseFloat(currentValues?.claim_adjustment_total_pr || 0) +
                    parseFloat(parseFloat(currentValues?.sl_coins || 0) != parseFloat(currentValues?.claim_coins || 0) ? parseFloat(currentValues?.claim_coins || 0) : parseFloat(0)) +
                    parseFloat(parseFloat(currentValues?.sl_deduct || 0) != parseFloat(currentValues?.claim_deduct || 0) ? parseFloat(currentValues?.claim_deduct || 0) : parseFloat(0)) +
                    parseFloat(parseFloat(currentValues?.sl_copay || 0) != parseFloat(currentValues?.claim_copay || 0) ? parseFloat(currentValues?.claim_copay || 0) : parseFloat(0))
                )).toFixed(2);
                eobFormSetValues(`claims.${index}.claim_patres`, amountClPatres,{ shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${index}.fake_sl_patres`, amountClPatres,{ shouldValidate: false, shouldDirty: false });
            }

            // Get updated values for claim total calculation
            const updatedValues = eobFormGetValues();
            const amountClTotal = parseFloat((parseFloat(updatedValues.claims?.[index]?.claim_billed || 0)) -
                (parseFloat(updatedValues.claims?.[index]?.claim_discount || 0) +
                    parseFloat(updatedValues.claims?.[index]?.claim_patres || 0) +
                    parseFloat(updatedValues.claims?.[index]?.claim_cob || 0) +
                    parseFloat(updatedValues.claims?.[index]?.claim_paid || 0) +
                    parseFloat(parseFloat(slAmountValue || 0) - parseFloat(parseFloat(updatedValues.claims?.[index]?.sl_patres || 0) - parseFloat(parseFloat(updatedValues.claims?.[index]?.sl_deduct || 0) + parseFloat(updatedValues.claims?.[index]?.sl_coins || 0) + parseFloat(updatedValues.claims?.[index]?.sl_copay || 0)))) +
                    parseFloat(parseFloat(updatedValues.claims?.[index]?.claim_adjustment_total || 0) - parseFloat(updatedValues.claims?.[index]?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${index}.claim_balance`, amountClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        default:
            break;
    }

    if(values?.qdx_status!='INCOMPLETE'){
    const transaction_type = eobFormGetValues('transaction_type')
    if(transaction_type==="PAYMENT835_LITE"){
         customFieldValidator([
            `claims.${index}.service_lines.${sfindex}.billed`,
            `claims.${index}.service_lines.${sfindex}.paid`,
        ]);
    }else{
        customFieldValidator([
        `remaining_balance`,
        `claims.${index}.service_lines.${sfindex}.billed`,
        `claims.${index}.service_lines.${sfindex}.discount`,
        `claims.${index}.service_lines.${sfindex}.allowed`,
        `claims.${index}.service_lines.${sfindex}.deduct`,
        `claims.${index}.service_lines.${sfindex}.coins`,
        `claims.${index}.service_lines.${sfindex}.copay`,
        `claims.${index}.service_lines.${sfindex}.cob`,
        `claims.${index}.service_lines.${sfindex}.paid`,
        `claims.${index}.service_lines.${sfindex}.amount`,
        `claims.${index}.service_lines.${sfindex}.balance`,
        `claims.${index}.claim_billed`,
        `claims.${index}.claim_discount`,
        `claims.${index}.claim_allowed`,
        `claims.${index}.claim_deduct`,
        `claims.${index}.claim_coins`,
        `claims.${index}.claim_copay`,
        `claims.${index}.claim_cob`,
        `claims.${index}.claim_paid`,
        `claims.${index}.claim_balance`]);
        }
    }


  
},[customFieldValidator,eobSetError,clearErrors,eobFormSetValues,eobFormGetValues,values,setFullClaimTotal,fullclaimTotal,startClaimOrder,activeclaim835Index]);

const changeClaimValue = useCallback((event, type, adjIndex)=>{
    const value = event.target.value;
    const claimIndex = 0
    // Get current form values
    const currentValues = eobFormGetValues();
    const activeClaim = currentValues.claims?.[0]
    let oldvalue = 0;
    if (type === 'amount') {
        oldvalue = activeClaim?.claim_adjustments?.[adjIndex]?.amount || 0;
    } else {
        oldvalue = activeClaim?.[type] || 0;
    }

    // Set the original field value first
    if (type === 'amount') {
        eobFormSetValues(`claims.${0}.claim_adjustments.${adjIndex}.amount`, (value||value===0)?parseFloat(value).toFixed(2) :"",{ shouldValidate: false, shouldDirty: false });
        customFieldValidator([`claims.${0}.claim_adjustments.${adjIndex}.group_code`]);
    } else {
        eobFormSetValues(`claims.${0}.${type}`, (value||value===0)?parseFloat(value).toFixed(2) :"",{ shouldValidate: false, shouldDirty: false });
    }

    switch (type) {
        case "claim_billed":
            const billedClTotal = parseFloat((parseFloat(value || 0)) -
                (parseFloat(activeClaim?.claim_discount || 0) +
                    parseFloat(activeClaim?.claim_patres || 0) +
                    parseFloat(activeClaim?.claim_cob || 0) +
                    parseFloat(activeClaim?.claim_paid || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                    parseFloat(parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_balance`, billedClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "claim_discount":
            const discountClTotal = parseFloat((parseFloat(activeClaim?.claim_billed || 0)) -
                (parseFloat(value || 0) +
                    parseFloat(activeClaim?.claim_patres || 0) +
                    parseFloat(activeClaim?.claim_cob || 0) +
                    parseFloat(activeClaim?.claim_paid || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                    parseFloat(parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_balance`, discountClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "claim_deduct":
            const deductClPatres = parseFloat(parseFloat(activeClaim?.sl_patres || 0) +
                parseFloat(activeClaim?.claim_adjustment_total_pr || 0) +
                parseFloat(parseFloat(activeClaim?.sl_deduct || 0) != parseFloat(value || 0) ? parseFloat(value || 0) : parseFloat(0)) +
                parseFloat(parseFloat(activeClaim?.sl_coins || 0) != parseFloat(activeClaim?.claim_coins || 0) ? parseFloat(activeClaim?.claim_coins || 0) : parseFloat(0)) +
                parseFloat(parseFloat(activeClaim?.sl_copay || 0) != parseFloat(activeClaim?.claim_copay || 0) ? parseFloat(activeClaim?.claim_copay || 0) : parseFloat(0))
            ).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_patres`, deductClPatres,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${claimIndex}.fake_sl_patres`, deductClPatres,{ shouldValidate: false, shouldDirty: false });

            const deductClTotal = parseFloat((parseFloat(activeClaim?.claim_billed || 0)) -
                (parseFloat(activeClaim?.claim_discount || 0) +
                    parseFloat(deductClPatres || 0) +
                    parseFloat(activeClaim?.claim_cob || 0) +
                    parseFloat(activeClaim?.claim_paid || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                    parseFloat(parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_balance`, deductClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "claim_coins":
            const coinsClPatres = parseFloat(parseFloat(activeClaim?.sl_patres || 0) +
                parseFloat(activeClaim?.claim_adjustment_total_pr || 0) +
                parseFloat(parseFloat(activeClaim?.sl_deduct || 0) != parseFloat(activeClaim?.claim_deduct || 0) ? parseFloat(activeClaim?.claim_deduct || 0) : parseFloat(0)) +
                parseFloat(parseFloat(activeClaim?.sl_coins || 0) != parseFloat(value || 0) ? parseFloat(value || 0) : parseFloat(0)) +
                parseFloat(parseFloat(activeClaim?.sl_copay || 0) != parseFloat(activeClaim?.claim_copay || 0) ? parseFloat(activeClaim?.claim_copay || 0) : parseFloat(0))
            ).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_patres`, coinsClPatres,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${claimIndex}.fake_sl_patres`, coinsClPatres,{ shouldValidate: false, shouldDirty: false });

            const coinsClTotal = parseFloat((parseFloat(activeClaim?.claim_billed || 0)) -
                (parseFloat(activeClaim?.claim_discount || 0) +
                    parseFloat(coinsClPatres || 0) +
                    parseFloat(activeClaim?.claim_cob || 0) +
                    parseFloat(activeClaim?.claim_paid || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                    parseFloat(parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_balance`, coinsClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "claim_copay":
            const copayClPatres = parseFloat(parseFloat(activeClaim?.sl_patres || 0) +
                parseFloat(activeClaim?.claim_adjustment_total_pr || 0) +
                parseFloat(parseFloat(activeClaim?.sl_deduct || 0) != parseFloat(activeClaim?.claim_deduct || 0) ? parseFloat(activeClaim?.claim_deduct || 0) : parseFloat(0)) +
                parseFloat(parseFloat(activeClaim?.sl_coins || 0) != parseFloat(activeClaim?.claim_coins || 0) ? parseFloat(activeClaim?.claim_coins || 0) : parseFloat(0)) +
                parseFloat(parseFloat(activeClaim?.sl_copay || 0) != parseFloat(value || 0) ? parseFloat(value || 0) : parseFloat(0))
            ).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_patres`, copayClPatres,{ shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${claimIndex}.fake_sl_patres`, copayClPatres,{ shouldValidate: false, shouldDirty: false });

            const copayClTotal = parseFloat((parseFloat(activeClaim?.claim_billed || 0)) -
                (parseFloat(activeClaim?.claim_discount || 0) +
                    parseFloat(copayClPatres || 0) +
                    parseFloat(activeClaim?.claim_cob || 0) +
                    parseFloat(activeClaim?.claim_paid || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                    parseFloat(parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_balance`, copayClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "claim_cob":
            const cobClTotal = parseFloat(parseFloat(activeClaim?.claim_billed || 0) -
                (parseFloat(activeClaim?.claim_discount || 0) +
                    parseFloat(activeClaim?.claim_patres || 0) +
                    parseFloat(value || 0) +
                    parseFloat(activeClaim?.claim_paid || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                    parseFloat(parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_balance`, cobClTotal,{ shouldValidate: false, shouldDirty: false });
            break;

        case "claim_paid":
            const paidClTotal = parseFloat((parseFloat(activeClaim?.claim_billed || 0)) -
                (parseFloat(activeClaim?.claim_discount || 0) +
                    parseFloat(activeClaim?.claim_patres || 0) +
                    parseFloat(activeClaim?.claim_cob || 0) +
                    parseFloat(value || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                    parseFloat(parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                )).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_balance`, paidClTotal,{ shouldValidate: false, shouldDirty: false });

            // Calculate paid total and remaining balance
            let paid_total = 0;
            let plb_total = eobFormGetValues('total_plb_amt')||0;

            fullclaimTotal?.current?.forEach((claim) => {
                paid_total += parseFloat(claim.paid_amount || 0);
            });
            paid_total = parseFloat(paid_total || 0) - parseFloat(oldvalue || 0) + parseFloat(value || 0);

            // currentValues?.plb_adjustments?.forEach((plb) => {
            //     plb_total += parseFloat(plb?.plb_amt || 0);
            // });

            const remainingBalance = parseFloat(parseFloat(currentValues.check_amount || 0) - parseFloat(paid_total || 0) + parseFloat(plb_total || 0)).toFixed(2);
            eobFormSetValues('remaining_balance', remainingBalance);

            const claim_paid = eobFormGetValues(`claims.${claimIndex}.claim_paid`);
            const updatedArray = manipulateTotalClaimPaidArray(fullclaimTotal?.current, (startClaimOrder+activeclaim835Index)-1, "update",{id:activeClaim?.claim_id||null,paid_amount:claim_paid});
            setFullClaimTotal(updatedArray);
            break;

        case "amount":
            const claimAmountValue = parseFloat((parseFloat(activeClaim?.claim_adjustment_total || 0) - parseFloat(oldvalue || 0)) + parseFloat(value || 0)).toFixed(2);
            eobFormSetValues(`claims.${claimIndex}.claim_adjustment_total`, claimAmountValue,{ shouldValidate: false, shouldDirty: false });

            if (activeClaim?.claim_adjustments?.[adjIndex]?.group_code === 'PR') {
                const claimAmountPrValue = parseFloat((parseFloat(activeClaim?.claim_adjustment_total_pr || 0) - parseFloat(oldvalue || 0)) + parseFloat(value || 0)).toFixed(2);
                eobFormSetValues(`claims.${claimIndex}.claim_adjustment_total_pr`, claimAmountPrValue,{ shouldValidate: false, shouldDirty: false });

                const amountClPatres = parseFloat(parseFloat(activeClaim?.sl_patres || 0) +
                    parseFloat(claimAmountPrValue || 0) +
                    parseFloat(parseFloat(activeClaim?.sl_deduct || 0) != parseFloat(activeClaim?.claim_deduct || 0) ? parseFloat(activeClaim?.claim_deduct || 0) : parseFloat(0)) +
                    parseFloat(parseFloat(activeClaim?.sl_coins || 0) != parseFloat(activeClaim?.claim_coins || 0) ? parseFloat(activeClaim?.claim_coins || 0) : parseFloat(0)) +
                    parseFloat(parseFloat(activeClaim?.sl_copay || 0) != parseFloat(activeClaim?.claim_copay || 0) ? parseFloat(activeClaim?.claim_copay || 0) : parseFloat(0))
                ).toFixed(2);
                eobFormSetValues(`claims.${claimIndex}.claim_patres`, amountClPatres,{ shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${claimIndex}.fake_sl_patres`, amountClPatres,{ shouldValidate: false, shouldDirty: false });

                const amountClTotalPR = parseFloat((parseFloat(activeClaim?.claim_billed || 0)) -
                    (parseFloat(activeClaim?.claim_discount || 0) +
                        parseFloat(amountClPatres || 0) +
                        parseFloat(activeClaim?.claim_cob || 0) +
                        parseFloat(activeClaim?.claim_paid || 0) +
                        parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                        parseFloat(parseFloat(claimAmountValue || 0) - parseFloat(claimAmountPrValue || 0))
                    )).toFixed(2);
                eobFormSetValues(`claims.${claimIndex}.claim_balance`, amountClTotalPR,{ shouldValidate: false, shouldDirty: false });
            } else {
                const amountClTotalNonPR = parseFloat((parseFloat(activeClaim?.claim_billed || 0)) -
                    (parseFloat(activeClaim?.claim_discount || 0) +
                        parseFloat(activeClaim?.claim_patres || 0) +
                        parseFloat(activeClaim?.claim_cob || 0) +
                        parseFloat(activeClaim?.claim_paid || 0) +
                        parseFloat(parseFloat(activeClaim?.sl_amount || 0) - parseFloat(parseFloat(activeClaim?.sl_patres || 0) - parseFloat(parseFloat(activeClaim?.sl_deduct || 0) + parseFloat(activeClaim?.sl_coins || 0) + parseFloat(activeClaim?.sl_copay || 0)))) +
                        parseFloat(parseFloat(claimAmountValue || 0) - parseFloat(activeClaim?.claim_adjustment_total_pr || 0))
                    )).toFixed(2);
                eobFormSetValues(`claims.${claimIndex}.claim_balance`, amountClTotalNonPR,{ shouldValidate: false, shouldDirty: false });
            }
            break;

        default:
            break;

        }
        
    customFieldValidator([
    `claims.${claimIndex}.claim_billed`,
    `claims.${claimIndex}.claim_discount`,
    `claims.${claimIndex}.claim_allowed`,
    `claims.${claimIndex}.claim_deduct`,
    `claims.${claimIndex}.claim_coins`,
    `claims.${claimIndex}.claim_copay`,
    `claims.${claimIndex}.claim_cob`,
    `claims.${claimIndex}.claim_paid`,
    `claims.${claimIndex}.claim_balance`,
    ]);



},[values,eobFormSetValues,eobFormGetValues,customFieldValidator])

const handleSLAssignBalanceValue = useCallback(async (e, serviceIndex, adjustmentIndex, field_type, type) => {
    if (!e.target.disabled) {
        const claims = eobFormGetValues('claims')
        const currentValues = claims?.length > 0?claims[0]:{}
        const currentValue = e.target.value;

        let balance = currentValues?.service_lines[serviceIndex]?.balance;
        let claim_balance = currentValues?.claim_balance;

        if (parseFloat(balance||0).toFixed(2) !== parseFloat(0).toFixed(2)) {
            // Check if current value exists and is not empty
        if (currentValue && currentValue.trim() !== '') {
            const numericCurrentValue = parseFloat(currentValue) || 0;
            const numericBalance = parseFloat(balance) || 0;
            
            // Add current value to balance
            balance = numericBalance + numericCurrentValue;
            
        }
            if (field_type === "amount") {
                e.target.value = parseFloat(balance).toFixed(2);
                handleChangeSLCalculation(e, serviceIndex, type)
            } else if (field_type === "adjustments") {
                e.target.value = parseFloat(balance).toFixed(2);
                handleChangeSLCalculation(e, serviceIndex, type, adjustmentIndex)
            }
        }
        if (parseFloat(claim_balance||0).toFixed(2) !== parseFloat(0).toFixed(2)) {
        // Check if current value exists and is not empty
        if (currentValue && currentValue.trim() !== '') {
            const numericCurrentValue = parseFloat(currentValue) || 0;
            const numericBalance = parseFloat(claim_balance) || 0;
            
            // Add current value to balance
            claim_balance = numericBalance + numericCurrentValue;
            
        }
            if (field_type === "claim") {
                e.target.value = parseFloat(claim_balance).toFixed(2);
                changeClaimValue(e, type)
            } else if (field_type === "claim_adjustments") {
                e.target.value = parseFloat(claim_balance).toFixed(2);
                changeClaimValue(e, type, adjustmentIndex)
            }
        }


    }

},[eobFormSetValues,eobFormGetValues])

const handleUpdateTotalClaimPaid = useCallback((index, type,customData={}) => {
  const updatedArray = manipulateTotalClaimPaidArray(fullclaimTotal?.current, index, type,customData);
  setFullClaimTotal(updatedArray);
},[setFullClaimTotal,fullclaimTotal]);

const handleSlAndClaimDifference = useCallback(async (claim) => {
    let sl_total = 0;
    let claim_total = 0;
    let diff = 0;
    
    sl_total = parseFloat(sl_total || 0) +
        parseFloat(claim?.sl_deduct || 0) +
        parseFloat(claim?.sl_coins || 0) +
        parseFloat(claim?.sl_copay || 0);

    claim_total = parseFloat(claim_total || 0) +
        parseFloat(claim?.claim_deduct || 0) +
        parseFloat(claim?.claim_coins || 0) +
        parseFloat(claim?.claim_copay || 0);

    if (Math.abs(parseFloat(sl_total).toFixed(2) - parseFloat(claim_total).toFixed(2)) != parseFloat(0).toFixed(2)) {
        diff = Math.abs(parseFloat(sl_total).toFixed(2) - parseFloat(claim_total).toFixed(2));
    }

    return diff;
},[eobFormSetValues,eobFormGetValues]);

const handleColumnCalculation = useCallback(async (sfindex, type) => {
    const currentValues = eobFormGetValues();
    const updatedClaims = [...currentValues.claims];
    
    if (updatedClaims[0]) {
        let sl_total = 0;

        if (type === "amount") {
            updatedClaims[0].service_lines?.forEach(service_line => {
                service_line?.adjustments?.forEach(adjustment => {
                    sl_total += parseFloat(adjustment?.amount || 0);
                });
            });
        } else {
            updatedClaims[0]?.service_lines?.forEach(service_line => {
                sl_total += parseFloat(service_line[type] || 0);
            });
        }

        const claim = updatedClaims[0];
        const formattedTotal = parseFloat(sl_total).toFixed(2);

        switch (type) {
            case "billed":
                eobFormSetValues(`claims.${0}.claim_billed`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_billed`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "discount":
                eobFormSetValues(`claims.${0}.claim_discount`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_discount`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "allowed":
                eobFormSetValues(`claims.${0}.claim_allowed`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_allowed`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "deduct":
                eobFormSetValues(`claims.${0}.claim_deduct`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_deduct`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "coins":
                eobFormSetValues(`claims.${0}.claim_coins`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_coins`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "copay":
                eobFormSetValues(`claims.${0}.claim_copay`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_copay`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "cob":
                eobFormSetValues(`claims.${0}.claim_cob`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_cob`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "paid":
                eobFormSetValues(`claims.${0}.claim_paid`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                eobFormSetValues(`claims.${0}.sl_paid`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            case "amount":
                eobFormSetValues(`claims.${0}.sl_amount`, formattedTotal, { shouldValidate: false, shouldDirty: false });
                break;
            default:
                break;
        }
    }
},[eobFormSetValues,eobFormGetValues]);

const handleRowCalculation = useCallback(async (sfIndex) => {
    const currentValues = eobFormGetValues();
    
    if (currentValues?.claims[0]) {
        const serviceLine = currentValues.claims[0].service_lines[sfIndex];
        
        if (serviceLine) {
            // Calculate adjustment amount total
            let amount_total = 0;
            serviceLine?.adjustments?.forEach((adjustment) => {
                amount_total += parseFloat(adjustment?.amount || 0);
            });

            // Calculate balance
            let total = 
                parseFloat(serviceLine?.billed || 0) -
                parseFloat(serviceLine?.discount || 0) -
                parseFloat(serviceLine?.deduct || 0) -
                parseFloat(serviceLine?.coins || 0) -
                parseFloat(serviceLine?.copay || 0) -
                parseFloat(serviceLine?.cob || 0) -
                parseFloat(serviceLine?.paid || 0) -
                parseFloat(amount_total || 0);

            // Handle -0.0 case
            if (parseFloat(total).toFixed(2) == -0.0) {
                total = parseFloat(0).toFixed(2);
            }

            // Update only the specific service line balance
            eobFormSetValues(
                `claims.${0}.service_lines.${sfIndex}.balance`, 
                parseFloat(total).toFixed(2), 
                { shouldValidate: false, shouldDirty: false }
            );
        }
    }
}, [eobFormSetValues, eobFormGetValues]);

const handleSlCalculation = useCallback(async () => {
    const currentValues = eobFormGetValues();
    
    if (currentValues.claims && currentValues.claims[0]) {
        const claim = currentValues.claims[0];
        let total = 0;
        let amount_total = 0;

        claim.claim_adjustments?.forEach((adjustment) => {
            amount_total = parseFloat(amount_total || 0) + parseFloat(adjustment.amount || 0);
        });

        total = parseFloat(claim.sl_billed || 0) -
            parseFloat(claim.sl_discount || 0) -
            parseFloat(claim.sl_deduct || 0) -
            parseFloat(claim.sl_coins || 0) -
            parseFloat(claim.sl_copay || 0) -
            parseFloat(claim.sl_cob || 0) -
            parseFloat(claim.sl_paid || 0) -
            parseFloat(claim.sl_amount || 0);

        const balanceValue = parseFloat(total || 0).toFixed(2);
        const finalBalance = parseFloat(total).toFixed(2) === "-0.00" ? "0.00" : balanceValue;
        
        eobFormSetValues(`claims.${0}.sl_balance`, finalBalance, { shouldValidate: false, shouldDirty: false });
    }

    return true;
},[eobFormSetValues,eobFormGetValues]);

const handlePatresCalculation = useCallback(async () => {
    const currentValues = eobFormGetValues();
    
    if (currentValues.claims && currentValues.claims[0]) {
        const claim = currentValues.claims[0];
        let total = 0;
        let fake_patres = 0;
        let adjustment_total = 0;

        claim.service_lines?.forEach((service_line) => {
            total = parseFloat(total || 0) +
                parseFloat(service_line.deduct || 0) +
                parseFloat(service_line.coins || 0) +
                parseFloat(service_line.copay || 0);

            service_line?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    total = parseFloat(total || 0) + parseFloat(adjustment?.amount || 0);
                }
            });

            service_line?.adjustments?.forEach((adjustment) => {
                adjustment_total = parseFloat(adjustment_total || 0) + parseFloat(adjustment?.amount || 0);
            });

            fake_patres = parseFloat(fake_patres || 0) +
                parseFloat(service_line.deduct || 0) +
                parseFloat(service_line.coins || 0) +
                parseFloat(service_line.copay || 0);

            service_line?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    fake_patres = parseFloat(fake_patres || 0) + parseFloat(adjustment?.amount || 0);
                }
            });
        });

        claim?.claim_adjustments?.forEach((adjustment) => {
            if (adjustment?.group_code === 'PR') {
                fake_patres = parseFloat(fake_patres || 0) + parseFloat(adjustment?.amount || 0);
            }
        });

        try {
            const payload = await handleSlAndClaimDifference(claim);
            fake_patres = parseFloat(fake_patres || 0) + parseFloat(payload || 0);
            
            eobFormSetValues(`claims.${0}.adjustment_total`, parseFloat(adjustment_total).toFixed(2), { shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${0}.sl_patres`, parseFloat(total).toFixed(2), { shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${0}.fake_sl_patres`, parseFloat(fake_patres).toFixed(2), { shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${0}.claim_patres`, parseFloat(fake_patres).toFixed(2), { shouldValidate: false, shouldDirty: false });
        } catch (error) {
            console.error('Error in handlePatresCalculation:', error);
        }
    }
},[eobFormSetValues,eobFormGetValues]);

const handleClaimPatresCalculation = useCallback(async () => {
    const currentValues = eobFormGetValues();
    
    if (currentValues.claims && currentValues.claims[0]) {
        const claim = currentValues.claims[0];
        let total = 0;
        let fake_patres = 0;
        let adjustment_total = 0;

        claim.service_lines?.forEach((service_line) => {
            total = parseFloat(total || 0) +
                parseFloat(service_line.deduct || 0) +
                parseFloat(service_line.coins || 0) +
                parseFloat(service_line.copay || 0);

            service_line?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    total = parseFloat(total || 0) + parseFloat(adjustment?.amount || 0);
                }
            });

            service_line?.adjustments?.forEach((adjustment) => {
                adjustment_total = parseFloat(adjustment_total || 0) + parseFloat(adjustment?.amount || 0);
            });

            fake_patres = parseFloat(fake_patres || 0) +
                parseFloat(service_line.deduct || 0) +
                parseFloat(service_line.coins || 0) +
                parseFloat(service_line.copay || 0);

            service_line?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    fake_patres = parseFloat(fake_patres || 0) + parseFloat(adjustment?.amount || 0);
                }
            });
        });

        claim?.claim_adjustments?.forEach((adjustment) => {
            if (adjustment?.group_code === 'PR') {
                fake_patres = parseFloat(fake_patres || 0) + parseFloat(adjustment?.amount || 0);
            }
        });

        try {
            const payload = await handleSlAndClaimDifference(claim);
            fake_patres = parseFloat(fake_patres || 0) + parseFloat(payload || 0);
            
            eobFormSetValues(`claims.${0}.adjustment_total`, parseFloat(adjustment_total).toFixed(2), { shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${0}.sl_patres`, parseFloat(total).toFixed(2), { shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${0}.fake_sl_patres`, parseFloat(fake_patres).toFixed(2), { shouldValidate: false, shouldDirty: false });
            eobFormSetValues(`claims.${0}.claim_patres`, parseFloat(fake_patres).toFixed(2), { shouldValidate: false, shouldDirty: false });
        } catch (error) {
            console.error('Error in handleClaimPatresCalculation:', error);
        }
    }

    return true;
},[eobFormSetValues,eobFormGetValues]);

const handleClaimCalculation = useCallback(async () => {
    const currentValues = eobFormGetValues();
    
    if (currentValues?.claims && currentValues.claims[0]) {
        const claim = currentValues.claims[0];
        let total = 0;
        let amount_total = 0;

        claim.claim_adjustments?.forEach((adjustment) => {
            amount_total = parseFloat(amount_total || 0) + parseFloat(adjustment?.amount || 0);
        });

        total = parseFloat(claim.claim_billed || 0) -
            parseFloat(claim.claim_discount || 0) -
            parseFloat(claim.claim_deduct || 0) -
            parseFloat(claim.claim_coins || 0) -
            parseFloat(claim.claim_copay || 0) -
            parseFloat(claim.claim_cob || 0) -
            parseFloat(claim.claim_paid || 0) -
            parseFloat(claim.adjustment_total || 0) -
            parseFloat(amount_total || 0);

        eobFormSetValues(`claims.${0}.claim_balance`, parseFloat(total || 0).toFixed(2), { shouldValidate: false, shouldDirty: false });
    }

    await handleClaimPatresCalculation();
    return true;
},[eobFormSetValues,eobFormGetValues]);

const handleRemainingBalanceCalculation = useCallback(async () => {
    const total_plb_amt = eobFormGetValues('total_plb_amt')||0
    const check_amount = eobFormGetValues('check_amount')
    const { remaining } = calculateRemainingPlbPaidTotals(fullclaimTotal?.current, total_plb_amt,check_amount,'paid_amount');
    eobFormSetValues('remaining_balance', parseFloat(remaining).toFixed(2), { shouldValidate: false, shouldDirty: false });
    customFieldValidator([`remaining_balance`]);
},[customFieldValidator,fullclaimTotal,calculateRemainingPlbPaidTotals,eobFormGetValues]);

const handleAllocateValuesServiceLine = useCallback(async () => {
    const currentValues = eobFormGetValues();
    const claim835Index = 0
    let sl_discount = 0;
    let sl_allowed = 0;
    let sl_deduct = 0;
    let sl_coins = 0;
    let sl_copay = 0;
    let sl_cob = 0;
    let sl_paid = 0;
    let sl_balance = 0;
    let sl_amount = 0;

    const newData = {
        ...currentValues,
        claims: currentValues.claims.map((claim, index) => {
            if (index === claim835Index && parseFloat(claim?.claim_billed) > 0) {
                const isClaimAdjGreater = claim.claim_adjustments?.length > 1;
                let isServiceLineAdjGreater = false;
                claim.service_lines?.forEach((ite) => {
                    if (ite.adjustments?.length > 1) {
                        isServiceLineAdjGreater = true;
                        return;
                    }
                });

                const totals_dict = claim.service_lines.reduce((acc, item) => {
                    if (parseFloat(item.discount) === 0) {
                        acc.discount_billed += parseFloat(item.billed);
                    }
                    if (parseFloat(item.allowed) === 0) {
                        acc.allowed_billed += parseFloat(item.billed);
                    }
                    if (parseFloat(item.deduct) === 0) {
                        acc.deduct_billed += parseFloat(item.billed);
                    }
                    if (parseFloat(item.coins) === 0) {
                        acc.coins_billed += parseFloat(item.billed);
                    }
                    if (parseFloat(item.copay) === 0) {
                        acc.copay_billed += parseFloat(item.billed);
                    }
                    if (parseFloat(item.cob) === 0) {
                        acc.cob_billed += parseFloat(item.billed);
                    }
                    if (parseFloat(item.paid) === 0) {
                        acc.paid_billed += parseFloat(item.billed);
                    }
                    if (isClaimAdjGreater && item.adjustments?.some(i => parseFloat(i?.amount) === 0)) {
                        acc.amount_billed += parseFloat(item.billed);
                    }
                    else if (parseFloat(item.adjustments[0]?.amount) === 0) {
                        acc.amount_billed += parseFloat(item.billed);
                    }
                    return acc;
                }, { discount_billed: 0, allowed_billed: 0, deduct_billed: 0, coins_billed: 0, copay_billed: 0, cob_billed: 0, paid_billed: 0, amount_billed: 0 });

                let total = 0;
                let fake_patres = 0;
                let adjustment_total = 0;

                const updatedServiceLines = claim.service_lines.map(
                    (serviceLine, sfindex) => {
                        if(!(serviceLine?.billed||0 > 0)){
                            return serviceLine
                        }
                        let amount_total = 0;
                        let final_dict = {
                            ...serviceLine,
                        };
                        let current_discount = 0;
                        if ((serviceLine?.discount == "" || serviceLine?.discount != 0) && claim?.claim_discount != 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                            current_discount = parseFloat(claim?.claim_discount) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.discount_billed ? totals_dict?.discount_billed : 0)) * parseFloat(serviceLine?.billed);
                            final_dict = {
                                ...final_dict,
                                discount: parseFloat(current_discount).toFixed(2),
                            };
                        }

                        let current_allowed = 0;
                        if ((serviceLine?.allowed == "" || serviceLine?.allowed != 0) && claim?.claim_allowed != 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                            current_allowed = parseFloat(claim?.claim_allowed) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.allowed_billed ? totals_dict?.allowed_billed : 0)) * parseFloat(serviceLine?.billed);
                            final_dict = {
                                ...final_dict,
                                allowed: parseFloat(current_allowed).toFixed(2),
                            };
                        }

                        let current_deduct = 0;
                        if ((serviceLine?.deduct == "" || serviceLine?.deduct != 0) && claim?.claim_deduct != 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                            current_deduct = parseFloat(claim?.claim_deduct) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.deduct_billed ? totals_dict?.deduct_billed : 0)) * parseFloat(serviceLine?.billed);
                            final_dict = {
                                ...final_dict,
                                deduct: parseFloat(current_deduct).toFixed(2),
                            };
                        }

                        let current_coins = 0;
                        if ((serviceLine?.coins == "" || serviceLine?.coins != 0) && claim?.claim_coins != 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                            current_coins = parseFloat(claim?.claim_coins) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.coins_billed ? totals_dict?.coins_billed : 0)) * parseFloat(serviceLine?.billed);
                            final_dict = {
                                ...final_dict,
                                coins: parseFloat(current_coins).toFixed(2),
                            };
                        }

                        let current_copay = 0;
                        if ((serviceLine?.copay == "" || serviceLine?.copay != 0) && claim?.claim_copay != 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                            current_copay = parseFloat(claim?.claim_copay) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.copay_billed ? totals_dict?.copay_billed : 0)) * parseFloat(serviceLine?.billed);
                            final_dict = {
                                ...final_dict,
                                copay: parseFloat(current_copay).toFixed(2),
                            };
                        }

                        let current_cob = 0;
                        if ((serviceLine?.cob == "" || serviceLine?.cob != 0) && claim?.claim_cob != 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                            current_cob = parseFloat(claim?.claim_cob) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.cob_billed ? totals_dict?.cob_billed : 0)) * parseFloat(serviceLine?.billed);
                            final_dict = {
                                ...final_dict,
                                cob: parseFloat(current_cob).toFixed(2),
                            };
                        }

                        let current_paid = 0;
                        if ((serviceLine?.paid == "" || serviceLine?.paid != 0) && claim?.claim_paid != 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                            current_paid = parseFloat(claim?.claim_paid) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.paid_billed ? totals_dict?.paid_billed : 0)) * parseFloat(serviceLine?.billed);
                            final_dict = {
                                ...final_dict,
                                paid: parseFloat(current_paid).toFixed(2),
                            };
                        }

                        let current_amount = 0;
                        if ((!isClaimAdjGreater && !isServiceLineAdjGreater)) {
                            if ((serviceLine?.adjustments?.[0]?.amount == "" || serviceLine?.adjustments?.[0]?.amount != 0) && claim?.claim_adjustments?.[0]?.amount > 0 && parseFloat(serviceLine?.billed ? serviceLine?.billed : 0) > 0) {
                                current_amount = parseFloat(claim?.claim_adjustments?.[0]?.amount) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.amount_billed ? totals_dict?.amount_billed : 0)) * parseFloat(serviceLine?.billed);
                                const adjustment = structuredClone(final_dict?.adjustments);
                                adjustment[0] = {
                                    adjustment_id: "",
                                    amount: parseFloat(current_amount).toFixed(2),
                                    pc: claim?.claim_adjustments?.[0]?.pc,
                                    reason_code: claim?.claim_adjustments?.[0]?.reason_code,
                                    rmk: claim?.claim_adjustments?.[0]?.rmk,
                                    group_code: claim?.claim_adjustments?.[0]?.group_code,
                                };

                                final_dict = {
                                    ...final_dict,
                                    adjustments: adjustment,
                                };
                            } else {
                                const adjustment = structuredClone(final_dict?.adjustments);
                                current_amount = adjustment?.reduce((acc, item) => {
                                    acc += parseFloat(item?.amount ? item?.amount : 0);
                                    return acc;
                                }, 0);
                            }
                        } else if (isClaimAdjGreater) {
                            const claim_adjustment = structuredClone(claim?.claim_adjustments);
                            const adjustment = structuredClone(final_dict?.adjustments);
                            const isZeroExist = adjustment.some((i => parseFloat(i.amount) === 0));
                            const serv_adj = [];
                            if (!isZeroExist) {
                                claim_adjustment?.forEach((c_adjustment, c_ind) => {
                                    if (c_adjustment?.amount != 0 && c_adjustment?.amount != "") {
                                        const adj_amount = parseFloat(c_adjustment?.amount) / parseFloat(parseFloat(claim?.claim_billed) - parseFloat(totals_dict?.amount_billed ? totals_dict?.amount_billed : 0)) * parseFloat(serviceLine?.billed);
                                        current_amount += parseFloat(parseFloat(adj_amount).toFixed(2));
                                        const dict = {
                                            adjustment_id: "",
                                            amount: parseFloat(adj_amount).toFixed(2),
                                            pc: c_adjustment?.pc,
                                            reason_code: c_adjustment?.reason_code,
                                            rmk: c_adjustment?.rmk,
                                            group_code: c_adjustment?.group_code,
                                        };
                                        serv_adj.push(dict);
                                    }
                                });
                                if (serv_adj.length > 0) {
                                    final_dict = {
                                        ...final_dict,
                                        adjustments: serv_adj,
                                    };
                                }
                            }
                        } else {
                            const adjustment = structuredClone(final_dict?.adjustments);
                            current_amount = adjustment?.reduce((acc, item) => {
                                acc += parseFloat(item?.amount);
                                return acc;
                            }, 0);
                        }
                        
                        final_dict?.adjustments?.map((adjustment, ind) => {
                            amount_total =
                                parseFloat(amount_total ? amount_total : 0) +
                                parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                        });

                        sl_discount = parseFloat(parseFloat(sl_discount ? sl_discount : 0) + parseFloat(parseFloat(current_discount ? current_discount : 0).toFixed(2))).toFixed(2);
                        sl_allowed = parseFloat(parseFloat(sl_allowed ? sl_allowed : 0) + parseFloat(parseFloat(current_allowed ? current_allowed : 0).toFixed(2))).toFixed(2);
                        sl_deduct = parseFloat(parseFloat(sl_deduct ? sl_deduct : 0) + parseFloat(parseFloat(current_deduct ? current_deduct : 0).toFixed(2))).toFixed(2);
                        sl_coins = parseFloat(parseFloat(sl_coins ? sl_coins : 0) + parseFloat(parseFloat(current_coins ? current_coins : 0).toFixed(2))).toFixed(2);
                        sl_copay = parseFloat(parseFloat(sl_copay ? sl_copay : 0) + parseFloat(parseFloat(current_copay ? current_copay : 0).toFixed(2))).toFixed(2);
                        sl_cob = parseFloat(parseFloat(sl_cob ? sl_cob : 0) + parseFloat(parseFloat(current_cob ? current_cob : 0).toFixed(2))).toFixed(2);
                        sl_paid = parseFloat(parseFloat(sl_paid ? sl_paid : 0) + parseFloat(parseFloat(current_paid ? current_paid : 0).toFixed(2))).toFixed(2);
                        sl_amount = parseFloat(parseFloat(sl_amount ? sl_amount : 0) + parseFloat(parseFloat(current_amount ? current_amount : 0).toFixed(2))).toFixed(2);

                        const total_balance =
                            parseFloat(parseFloat(final_dict?.billed ? final_dict?.billed : 0) -
                                parseFloat(final_dict?.discount ? final_dict?.discount : 0) -
                                parseFloat(final_dict?.deduct ? final_dict?.deduct : 0) -
                                parseFloat(final_dict?.coins ? final_dict?.coins : 0) -
                                parseFloat(final_dict?.copay ? final_dict?.copay : 0) -
                                parseFloat(final_dict?.cob ? final_dict?.cob : 0) -
                                parseFloat(final_dict?.paid ? final_dict?.paid : 0) -
                                parseFloat(amount_total ? amount_total : 0)).toFixed(2);

                        // ==================PATRES==================
                        total =
                            parseFloat(total ? total : 0) +
                            parseFloat(final_dict.deduct ? final_dict.deduct : 0) +
                            parseFloat(final_dict.coins ? final_dict.coins : 0) +
                            parseFloat(final_dict.copay ? final_dict.copay : 0);

                        final_dict?.adjustments?.forEach((adjustment, ind) => {
                            if (adjustment?.group_code == 'PR') {
                                total =
                                    parseFloat(total ? total : 0) +
                                    parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                            }
                        });

                        final_dict?.adjustments?.forEach((adjustment, ind) => {
                            adjustment_total =
                                parseFloat(adjustment_total ? adjustment_total : 0) +
                                parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                        });

                        fake_patres =
                            parseFloat(fake_patres ? fake_patres : 0) +
                            parseFloat(final_dict.deduct ? final_dict.deduct : 0) +
                            parseFloat(final_dict.coins ? final_dict.coins : 0) +
                            parseFloat(final_dict.copay ? final_dict.copay : 0);

                        final_dict?.adjustments?.forEach((adjustment, ind) => {
                            if (adjustment?.group_code == 'PR') {
                                fake_patres =
                                    parseFloat(fake_patres ? fake_patres : 0) +
                                    parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                            }
                        });
                        sl_balance += parseFloat(total_balance ? total_balance : 0);

                        return { ...final_dict, balance: parseFloat(total_balance ? total_balance : 0).toFixed(2) };
                    }
                );

                // CLAIM PATRESS
                claim?.claim_adjustments?.forEach((adjustment, ind) => {
                    if (adjustment?.group_code == 'PR') {
                        fake_patres =
                            parseFloat(fake_patres ? fake_patres : 0) +
                            parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                    }
                });

                let sl_total_diff = 0;
                let claim_total_diff = 0;
                let diff = 0;

                sl_total_diff = parseFloat(sl_total_diff ? sl_total_diff : 0) +
                    parseFloat(sl_deduct ? sl_deduct : 0) +
                    parseFloat(sl_coins ? sl_coins : 0) +
                    parseFloat(sl_copay ? sl_copay : 0);

                claim_total_diff = parseFloat(claim_total_diff ? claim_total_diff : 0) +
                    parseFloat(claim?.claim_deduct ? claim?.claim_deduct : 0) +
                    parseFloat(claim?.claim_coins ? claim?.claim_coins : 0) +
                    parseFloat(claim?.claim_copay ? claim?.claim_copay : 0);

                if (Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2)) != parseFloat(0).toFixed(2)) {
                    diff = Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2));
                }
                
                fake_patres = parseFloat(fake_patres ? fake_patres : 0) + parseFloat(diff ? diff : 0);
                claim.adjustment_total = parseFloat(adjustment_total).toFixed(2);
                claim.sl_patres = parseFloat(total).toFixed(2);
                claim.fake_sl_patres = parseFloat(fake_patres).toFixed(2);
                claim.claim_patres = parseFloat(fake_patres).toFixed(2);

                let cl_amount_total = 0;
                claim.claim_adjustments?.map((adjustment, ind) => {
                    cl_amount_total = parseFloat(cl_amount_total ? cl_amount_total : 0) + parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                });
                
                const claim_balance =
                    parseFloat(parseFloat(claim?.claim_billed ? claim?.claim_billed : 0) -
                        parseFloat(sl_discount ? sl_discount : 0) -
                        parseFloat(sl_deduct ? sl_deduct : 0) -
                        parseFloat(sl_coins ? sl_coins : 0) -
                        parseFloat(sl_copay ? sl_copay : 0) -
                        parseFloat(sl_cob ? sl_cob : 0) -
                        parseFloat(sl_paid ? sl_paid : 0) -
                        parseFloat(cl_amount_total ? cl_amount_total : 0) -
                        parseFloat(sl_amount ? sl_amount : 0)).toFixed(2);
                        
                const sl_balance2 =
                    parseFloat(parseFloat(claim?.claim_billed ? claim?.claim_billed : 0) -
                        parseFloat(sl_discount ? sl_discount : 0) -
                        parseFloat(sl_deduct ? sl_deduct : 0) -
                        parseFloat(sl_coins ? sl_coins : 0) -
                        parseFloat(sl_copay ? sl_copay : 0) -
                        parseFloat(sl_cob ? sl_cob : 0) -
                        parseFloat(sl_paid ? sl_paid : 0) -
                        parseFloat(sl_amount ? sl_amount : 0)).toFixed(2);

                return {
                    ...claim,
                    sl_discount: sl_discount,
                    sl_allowed: sl_allowed,
                    sl_deduct: sl_deduct,
                    sl_coins: sl_coins,
                    sl_copay: sl_copay,
                    sl_cob: sl_cob,
                    sl_paid: sl_paid,
                    sl_amount: sl_amount,
                    sl_balance: sl_balance2,
                    claim_balance: claim_balance,
                    service_lines: updatedServiceLines,
                };
            }

            return claim;
        }),
    };

    // Update all form values at once
    loadEobFormdata(newData);
    triggerEobValidation()
},[eobFormGetValues,loadEobFormdata,triggerEobValidation]);

const handleReCalculate = useCallback(async () => {
    const currentValues = eobFormGetValues();

    const newData = {
        ...currentValues,
        claims: currentValues.claims.map((claim, index) => {

            let total = 0;
            let fake_patres = 0;
            let adjustment_total = 0;

            let sl_paid = 0;
            let sl_discount = 0;
            let sl_allowed = 0;
            let sl_deduct = 0;
            let sl_coins = 0;
            let sl_copay = 0;
            let sl_cob = 0;
            let sl_balance = 0;
            let sl_amount = 0;
            
            const updatedServiceLines = claim.service_lines.map(
                (serviceLine, sfindex) => {
                    let amount_total = 0;
                    let final_dict = {
                        ...serviceLine,
                    };

                    final_dict?.adjustments?.map((adjustment, ind) => {
                        amount_total =
                            parseFloat(amount_total ? amount_total : 0) +
                            parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                    });
                    
                    let current_amount = 0;

                    const adjustment = structuredClone(final_dict?.adjustments);
                    current_amount = adjustment?.reduce((acc, item) => {
                        acc += parseFloat(item?.amount ? item?.amount : 0);
                        return acc;
                    }, 0);
                    
                    sl_discount = parseFloat(parseFloat(sl_discount ? sl_discount : 0) + parseFloat(parseFloat(serviceLine?.discount ? serviceLine?.discount : 0).toFixed(2))).toFixed(2);
                    sl_allowed = parseFloat(parseFloat(sl_allowed ? sl_allowed : 0) + parseFloat(parseFloat(serviceLine?.allowed ? serviceLine?.allowed : 0).toFixed(2))).toFixed(2);
                    sl_deduct = parseFloat(parseFloat(sl_deduct ? sl_deduct : 0) + parseFloat(parseFloat(serviceLine?.deduct ? serviceLine?.deduct : 0).toFixed(2))).toFixed(2);
                    sl_coins = parseFloat(parseFloat(sl_coins ? sl_coins : 0) + parseFloat(parseFloat(serviceLine?.coins ? serviceLine?.coins : 0).toFixed(2))).toFixed(2);
                    sl_copay = parseFloat(parseFloat(sl_copay ? sl_copay : 0) + parseFloat(parseFloat(serviceLine?.copay ? serviceLine?.copay : 0).toFixed(2))).toFixed(2);
                    sl_cob = parseFloat(parseFloat(sl_cob ? sl_cob : 0) + parseFloat(parseFloat(serviceLine?.cob ? serviceLine?.cob : 0).toFixed(2))).toFixed(2);
                    sl_paid = parseFloat(parseFloat(sl_paid ? sl_paid : 0) + parseFloat(parseFloat(serviceLine?.paid ? serviceLine?.paid : 0).toFixed(2))).toFixed(2);

                    sl_amount = parseFloat(parseFloat(sl_amount ? sl_amount : 0) + parseFloat(parseFloat(current_amount ? current_amount : 0).toFixed(2))).toFixed(2);
                    
                    const total_balance =
                        parseFloat(final_dict?.billed ? final_dict?.billed : 0) -
                        parseFloat(final_dict?.discount ? final_dict?.discount : 0) -
                        parseFloat(final_dict?.deduct ? final_dict?.deduct : 0) -
                        parseFloat(final_dict?.coins ? final_dict?.coins : 0) -
                        parseFloat(final_dict?.copay ? final_dict?.copay : 0) -
                        parseFloat(final_dict?.cob ? final_dict?.cob : 0) -
                        parseFloat(final_dict?.paid ? final_dict?.paid : 0) -
                        parseFloat(amount_total ? amount_total : 0);

                    // ==================PATRES==================
                    total =
                        parseFloat(total ? total : 0) +
                        parseFloat(final_dict.deduct ? final_dict.deduct : 0) +
                        parseFloat(final_dict.coins ? final_dict.coins : 0) +
                        parseFloat(final_dict.copay ? final_dict.copay : 0);

                    final_dict?.adjustments?.forEach((adjustment, ind) => {
                        if (adjustment?.group_code == 'PR') {
                            total =
                                parseFloat(total ? total : 0) +
                                parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                        }
                    });

                    final_dict?.adjustments?.forEach((adjustment, ind) => {
                        adjustment_total =
                            parseFloat(adjustment_total ? adjustment_total : 0) +
                            parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                    });

                    fake_patres =
                        parseFloat(fake_patres ? fake_patres : 0) +
                        parseFloat(final_dict.deduct ? final_dict.deduct : 0) +
                        parseFloat(final_dict.coins ? final_dict.coins : 0) +
                        parseFloat(final_dict.copay ? final_dict.copay : 0);

                    final_dict?.adjustments?.forEach((adjustment, ind) => {
                        if (adjustment?.group_code == 'PR') {
                            fake_patres =
                                parseFloat(fake_patres ? fake_patres : 0) +
                                parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                        }
                    });
                    
                    sl_balance += parseFloat(total_balance ? total_balance : 0);

                    return { ...final_dict, balance: parseFloat(total_balance ? total_balance : 0).toFixed(2) };
                }
            );

            // CLAIM PATRESS
            claim?.claim_adjustments?.forEach((adjustment, ind) => {
                if (adjustment?.group_code == 'PR') {
                    fake_patres =
                        parseFloat(fake_patres ? fake_patres : 0) +
                        parseFloat(adjustment?.amount ? adjustment?.amount : 0);
                }
            });

            let sl_total_diff = 0;
            let claim_total_diff = 0;
            let diff = 0;
            
            sl_total_diff = parseFloat(sl_total_diff ? sl_total_diff : 0) +
                parseFloat(sl_deduct ? sl_deduct : 0) +
                parseFloat(sl_coins ? sl_coins : 0) +
                parseFloat(sl_copay ? sl_copay : 0);

            claim_total_diff = parseFloat(claim_total_diff ? claim_total_diff : 0) +
                parseFloat(sl_deduct ? sl_deduct : 0) +
                parseFloat(sl_coins ? sl_coins : 0) +
                parseFloat(sl_copay ? sl_copay : 0);

            if (Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2)) != parseFloat(0).toFixed(2)) {
                diff = Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2));
            }
            
            fake_patres = parseFloat(fake_patres ? fake_patres : 0) + parseFloat(diff ? diff : 0);
            claim.adjustment_total = parseFloat(adjustment_total).toFixed(2);
            claim.sl_patres = parseFloat(total).toFixed(2);
            claim.fake_sl_patres = parseFloat(fake_patres).toFixed(2);
            claim.claim_patres = parseFloat(fake_patres).toFixed(2);

            let cl_amount_total = 0;
            claim.claim_adjustments?.map((adjustment, ind) => {
                cl_amount_total = parseFloat(cl_amount_total ? cl_amount_total : 0) + parseFloat(adjustment?.amount ? adjustment?.amount : 0);
            });
            
            const claim_balance =
                parseFloat(parseFloat(claim?.claim_billed ? claim?.claim_billed : 0) -
                    parseFloat(sl_discount ? sl_discount : 0) -
                    parseFloat(sl_deduct ? sl_deduct : 0) -
                    parseFloat(sl_coins ? sl_coins : 0) -
                    parseFloat(sl_copay ? sl_copay : 0) -
                    parseFloat(sl_cob ? sl_cob : 0) -
                    parseFloat(sl_paid ? sl_paid : 0) -
                    parseFloat(cl_amount_total ? cl_amount_total : 0) -
                    parseFloat(sl_amount ? sl_amount : 0)).toFixed(2);
                    
            const sl_balance2 =
                parseFloat(parseFloat(claim?.claim_billed ? claim?.claim_billed : 0) -
                    parseFloat(sl_discount ? sl_discount : 0) -
                    parseFloat(sl_deduct ? sl_deduct : 0) -
                    parseFloat(sl_coins ? sl_coins : 0) -
                    parseFloat(sl_copay ? sl_copay : 0) -
                    parseFloat(sl_cob ? sl_cob : 0) -
                    parseFloat(sl_paid ? sl_paid : 0) -
                    parseFloat(sl_amount ? sl_amount : 0)).toFixed(2);

            return {
                ...claim,
                sl_discount: sl_discount,
                sl_allowed: sl_allowed,
                sl_deduct: sl_deduct,
                sl_coins: sl_coins,
                sl_copay: sl_copay,
                sl_cob: sl_cob,
                sl_paid: sl_paid,
                sl_amount: sl_amount,
                sl_balance: sl_balance2,
                claim_discount: sl_discount,
                claim_allowed: sl_allowed,
                claim_deduct: sl_deduct,
                claim_coins: sl_coins,
                claim_copay: sl_copay,
                claim_cob: sl_cob,
                claim_paid: sl_paid,
                claim_balance: claim_balance,
                service_lines: updatedServiceLines,
            };
        }),
    };

    // Update all form values at once
    loadEobFormdata(newData);
},[eobFormGetValues,loadEobFormdata,triggerEobValidation]);
const handlePageNavigate = useCallback(async (type) => {
    const {claims,transaction_type} = values
    if (isQdxTransactionType(transaction_type)) {
        if (claims && claims.length > 0) {
            jumpToPage(claims[0].page_from )
        }
    }
    else if (transaction_type == "PAYMENT835_LITE") {
        if (claims && claims.length > 0) {
            jumpToPage(claims[0].page_from )
        }
    }
    else if (transaction_type == "CORRESPONDENCE") {
        if (claims && claims.length > 0) {
            jumpToPage(claims[0].page_from )
        }
    }
},[values]);

const handleClickPageFromAndTo = useCallback(async (e,setLocalValue=null) => {
    const {name} = e.target
    const nameStr = String(name).toLowerCase();
    // Check if name contains valid page range pattern
    const hasPageFrom = nameStr.includes('page_from');
    const hasPageTo = nameStr.includes('page_to');
    if(hasPageFrom || hasPageTo){
        // eobFormSetValues(name,currentPdfPage)
        if(setLocalValue){
            setLocalValue(currentPdfPage)
        }
        // customFieldValidator([name])
    }
},[currentPdfPage,customFieldValidator]);

const hasFormErrors = Object.keys(eobFormErrors).length > 0;
const hasFormClaimsErrors = Object.keys(eobFormErrors?.claims||{}).length > 0;

const isClaimFormValid = useMemo(() => {    
    return validateAllExceptIndex(-1, false);
}, [hasFormClaimsErrors, fullclaimData, values?.qdx_status]);

const isValidationCompleted = isClaimFormValid && !hasFormErrors;

const checkFormValidation = useCallback((status) => {
    return status === "partial_save" ? isClaimFormValid : isValidationCompleted;
}, [isClaimFormValid, isValidationCompleted]);

function openMultiClaimCorrSwal(onSuccess) {
  Swal.fire({
    title: "This job contains multiple claims. Do you want to continue?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    confirmButtonColor: '#6ba2b6',
    cancelButtonColor: "#6c757d", 
  }).then((result) => {
    if (result.isConfirmed) {
      if (typeof onSuccess === "function") {
        onSuccess(); 
      }
    } else if (result.isDismissed) {
      console.log("User clicked Cancel");
     
    }
  });
}


// EOB Form Submit
const onEobFormSubmit = useCallback(
    // async (data,event ,isCoppresMultipleClaimpopup) => {
      
    //     if (!data || (!checkFormValidation(event?.status||"")&&data?.qdx_status !== "INCOMPLETE")) return ;
    //     if( (!isCoppresMultipleClaimpopup) && !(event?.is_qaModal)&& data?.transaction_type ==="CORRESPONDENCE"  &&fullclaimData?.length> 1 ){openMultiClaimCorrSwal(()=>onEobFormSubmit(data ,{type:"submit" ,is_qaModal:false},true)) ;return}
    //     handleQaErrorCheck('save_or_next_or_copy')
    //     const isGridEdited = getGridEdited()
    //     const isGridHeaderEdited = hasQAErrorInHeader(data)
          
    //     if(isQaScreen && !(event?.is_qaModal) && (isGridEdited || isGridHeaderEdited)) {openQaErrorModal();return}else{closeQaErrorModal()}

    //     setGridFormLoader(true)
    //     const gd_fields = getGridTotalFieldsCount()
        
    //     const status = event?.status||"";
    //     const rejection_reason = event?.message||"";
    //     const {
    //         claims = [],
    //         db_order="",
    //         del_clm = {},
    //         del_plb={},
    //         del_sl = {},
    //         del_adjust_sl = {},
    //         del_adjust_clm = {},
    //         next_id = null,
    //         prev_id = null,
    //         plb_adjustments = [],
    //         transaction_type="PAYMENT835",
    //         qa_error_type_comment=null,
    //         qa_error_type=null,
    //         is_claim_clear_all=false,
    //         is_plb_clear_all=false,
    //         ...headerData
    //     } = data;
    //     if(event?.type === "submit"&& !(event?.is_saveExit===true)){
    //       isSaveCurrentJobApi.current=false
    //         loadNextJob()
    //     }
    //     let claimParams, plbParams;
    //     const PATIENT_PAY = transaction_type === "PATIENT_PAY"

    //     if (!PATIENT_PAY) {
    //         if(data?.grid_customization !== "PLB_ONLY"){
    //             const updatedFullClaims = updateClaimAtIndex(fullclaimData, activeclaim835Index, claims[0]);
    //             const updated_claims = processEditedClaimsUltraFast(
    //                 updatedFullClaims,
    //                 startClaimOrder
    //             );
                
    //             claimParams = {
    //                 grid_edited:isGridEdited,
    //                 gd_fields,
    //                 work_type: getTaskType(),
    //                 transaction_type: transaction_type || "PAYMENT835",
    //                 db_order,
    //                 job: jobData?.job,
    //                 claims: updated_claims,
    //                 del_clm,
    //                 del_sl,
    //                 del_adjust_sl,
    //                 del_adjust_clm,
    //                 final_save: true,
    //                 status,
    //                 rejection_reason,
    //                 qa_error_type_comment,
    //                 qa_error_type,
    //                 is_clear_all:is_claim_clear_all
    //             };
    //         }
            
    //         plbParams = {
    //             work_type: getTaskType(),
    //             transaction_type: transaction_type || "PAYMENT835",
    //             job: jobData?.job,
    //             plbs: plb_adjustments,
    //             del_plb,
    //             is_clear_all:is_plb_clear_all
    //         };
    //     }

    //     const headerParams = {
    //         grid_edited:isGridEdited,
    //         gd_fields,
    //         status,
    //         rejection_reason,
    //         work_type: getTaskType(),
    //         transaction_type: transaction_type || "PAYMENT835",
    //         job: jobData?.job,
    //         header_data: { ...headerData },
    //         qa_error_type_comment,
    //         qa_error_type
    //     };

    //     const params = PATIENT_PAY 
    //         ? { headerParams }
    //         : { claimParams, headerParams, plbParams };

    //     const response = await finalSubmitJobDetailsSequential(params);
    //     // Check permissions for current job
    //     setGridFormLoader(false)
    //     if (response?.status_code == 400 && response?.errors && response?.errors?.assign_user?.length > 0) {
    //         showAlert("error",null,response?.errors?.assign_user[0])             
    //     }
    //     else if(response?.status===false){
    //         showAlert("error",null,'ERROR WHILE SAVING PREVIOUS JOB',{data,is_errorJob:true})
    //     }
    //     else{
    //       setToast({ status: true, type: "success", message: "Success" })
    //         // deleteIndexedData('grid_data_cache');
    //         // deleteIndexedData('visited_pages')
    //         if(event?.type==="submit"&& !(event?.is_saveExit===true)){
    //             if(jobData?.job){
    //                 const hasPermission = await checkUserPermissions();  
    //             }
    //         }else{
    //             handleNavigateDashBoard('Dashboard', '/admin/dashboard')
    //         }
    //     }
    // },
[fullclaimData, startClaimOrder, jobData?.job,activeclaim835Index,isValidationCompleted]
);

const handlePartialSubmit = useCallback(async (values) => {
    // Only validate claims fields
    const claimsValid = true;
    if (claimsValid) {
        const data = eobFormGetValues();
        onEobFormSubmit(data, values);
    }
},[eobFormGetValues,onEobFormSubmit]);
  // Reset 837
 

  const handleLoadOriginal = async () => {
    let apiSingleClaim = {}
    sethandleLoadOrginalLoader(true)
    if (!handleLoadOrginalLoader) {
      let order = values?.claims?.[0]?.auto_order;
      let job_id = values?.job
      let type = "loadorginal"

      let response = await getAutomationReset837ClaimNewGrid({ order, job_id, type });
      try {
        if (response?.status) {

          apiSingleClaim = response?.data;
          let headerData = response?.header_data

          if (Object.keys(apiSingleClaim ?? {}).length > 0) {
          }

          const claim = processClaimsAutomation({ ...values, claims: [apiSingleClaim] }, values?.transaction_type, true, false)   // (values, transactionType = "PAYMENT835", isPullNeeded = true, isLite = false)   

          let { first_837_claim } = values?.claims?.[0]


          if (first_837_claim === true) {
            const updateFormWithHeader = (headerData) => {


              const overrideKeys = [
                "payee_name",
                "payee_npi",
                "tax_identification_number",
                "payee_address",
                "payee_city",
                "payee_state",
                "payee_zip",
                "payee_page_from",
                "payee_page_to",
              ];
              const editedData = values?.edited_data || {}
              // merge values
              const updatedValues = {

                ...Object.fromEntries(
                  overrideKeys.map((key) => {
                    editedData[key] = headerData?.edited_data?.[key] || headerData?.[key].trim().length > 0 ? { auto: true } : {}
                    return [key, headerData?.[key] || ""]
                  }
                  )),
              };

              // update each key using setValue
              Object.entries(updatedValues).forEach(([key, value]) => {
                eobFormSetValues(key, value, { shouldValidate: true, shouldDirty: true });
              });
              eobFormSetValues('edited_data', editedData)

            };
            updateFormWithHeader(headerData);

          }
          eobFormSetValues('claims', claim?.claims)
          triggerEobValidation('claims.0')
        }

        // const editedDataAddedClaim = buildEditedClaim(claim)

        sethandleLoadOrginalLoader(false)
      } catch (error) {
        console.error("API call failed:", error);
        sethandleLoadOrginalLoader(false)
      }
    }
    sethandleLoadOrginalLoader(false)


  }
  const handleReset837 = async () => {
    let apiSingleClaim = {}
    sethandleReset837Loader(true)
    if (!handleLoadOrginalLoader) {
      let order = values?.claims?.[0]?.auto_order;
      let job_id = values?.job
      // let type = "loadorginal"

      let current835Index = structuredClone(activeclaim835Index)
      let response = await getAutomationReset837ClaimNewGrid({ order, job_id });
      try {
        if (response?.status) {

          apiSingleClaim = response?.data?.grid_data;
          const headerData = response?.header_data;

        

          if (Object.keys(apiSingleClaim ?? {}).length > 0) {

          }
        const claim = processClaimsAutomation({ ...values, claims: [apiSingleClaim] }, values?.transaction_type, true, false)   // (values, transactionType = "PAYMENT835", isPullNeeded = true, isLite = false)   

        let { first_837_claim } = values?.claims?.[0]


         if (first_837_claim === true) {
            const updateFormWithHeader = (headerData) => {


              const overrideKeys = [
                "payee_name",
                "payee_npi",
                "tax_identification_number",
                "payee_address",
                "payee_city",
                "payee_state",
                "payee_zip",
                "payee_page_from",
                "payee_page_to",
              ];
              const  editedData = values?.edited_data || {}
              // merge values
              const updatedValues = {

                ...Object.fromEntries(
                  overrideKeys.map((key) =>{
                    editedData[key] = headerData?.edited_data?.[key] ||   headerData?.[key].trim().length>0 ? {auto:true} :{}
                   return [key, headerData?.[key] || ""]
                  } 
                )),
              };

              // update each key using setValue
              Object.entries(updatedValues).forEach(([key, value]) => {
                eobFormSetValues(key, value, { shouldValidate: true, shouldDirty: true });
              });
            eobFormSetValues('edited_data', editedData)

            };
            updateFormWithHeader( headerData);

            
          }
          eobFormSetValues('claims', claim?.claims)
        }
        sethandleReset837Loader(false)
      } catch (error) {
        console.error("API call failed:", error);
        sethandleReset837Loader(false)
      }
    }

  }


  const handleMergeServiceline = () => {
    const claim_1 = fullclaimData?.[activeclaim835Index - 1]
    const claim_2 = values?.claims?.[0];
    const data = mergeTwoClaims(claim_1, claim_2)
    const calculatedClaim = processClaimsAutomation({ ...values, claims: [data] }, values?.transaction_type, true, false)
    
    setFullClaimData((prev) => {
      const updated = [...prev];
      // remove the claim at activeclaim835Index - 1
      updated.splice(activeclaim835Index - 1, 2);
      // insert the new calculated claim at the same index
      updated.splice(activeclaim835Index - 1, 0, calculatedClaim?.claims?.[0]);
      return updated;
    });
    setActiveclaim835Index(prev=>prev-1)
    setPagenateInputVal(prev=>prev-1)
    eobFormSetValues('claims', [calculatedClaim?.claims?.[0]], { shouldDirty: false, shouldValidate: false });
    triggerEobValidation('claims.0')

  }
  


const getGridTotalFieldsCount = (values) => {
    // const eobHeaderContainer = document.querySelector(".header-count-container");
    // const claimContainer = document.querySelector(".claim-count-container");

    // // helper: select fields with data-corress-disable != true
    // const validSelector = `
    //     input:not([data-corress-disable="true"]):not([data-not-take-field-count="true"]),
    //     select:not([data-corress-disable="true"]):not([data-not-take-field-count="true"])
    // `;

    // // 1. Claim fields (exclude sub-containers)
    // const eobHeaderFields = Array.from(eobHeaderContainer.querySelectorAll(validSelector)).filter(
    //     el =>
    //         !el.closest(
    //             ".plb-main-component-container"
    //         )
    // );
    // const claimFields = Array.from(claimContainer.querySelectorAll(validSelector)).filter(
    //     el =>
    //         !el.closest(
    //             ".serviceline-count-container, .service_line-adj-count-container, .claim-adj-count-container"
    //         )
    // );

    // // 2. Service line fields → only first <tr>, exclude adj + disabled
    // const serviceLineContainer = claimContainer.querySelector(".serviceline-count-container");
    // const firstTr = serviceLineContainer?.querySelector("tbody tr");
    // const serviceLineFields = firstTr
    //     ? Array.from(firstTr.querySelectorAll(validSelector)).filter(
    //           el => !el.closest(".service_line-adj-count-container")
    //       )
    //     : [];

    // // 3. Adj fields (separate)
    // const adjFields =
    //     serviceLineContainer?.querySelector(".service_line-adj-count-container")?.querySelectorAll(validSelector) ??
    //     [];

    // // 4. Clm Adj fields (separate)
    // const clmAdjFields =
    //     serviceLineContainer?.querySelector(".claim-adj-count-container")?.querySelectorAll(validSelector) ?? [];

    // const gd_fields = {
    //     clm: claimFields?.length||0,
    //     sl: serviceLineFields?.length||0,
    //     clm_adjust: clmAdjFields?.length||0,
    //     sl_adjust: adjFields?.length||0,
    //     plb: 5, // placeholder → fill if you have PLB container
    //     header: eobHeaderFields?.length||0, // placeholder → fill if you have Header container
    // };

    // return gd_fields;
};
    const showAssignTooltip = useCallback((is_multy=false) => {
        setAssignTooltip(true);
        if(jobData?.is_large_batch_job){
        if (jobData?.is_large_batch_job) {
            getSubJobUserData(jobData?.job)((response) => {
                // setJobUserData(response?.data);
                const subjobs = [];
                response?.data?.map((user, index) => {
                    subjobs.push({
                        value: user?.pk,
                        label: user?.unique + "|" + user?.from_page + "-" + user?.to_page + "|" + user?.staff_name,
                        staff_name: user?.staff_name,
                        staff_id: user?.staff_id,
                        page_range: user?.from_page + "-" + user?.to_page,
                        is_select: false,
                        is_active: user?.is_active,
                        assign_reason: "",
                        assignTo: user?.is_active ? "user" : "common"

                    })
                })
                setSubJobOptions(subjobs)
            });
        }
        }else{
            getJobStaffStatus(jobData.job)((response) => {
                if (response?.status) {
                    setUserStatus(response?.data)
                    if (response?.data?.is_active) {
                        setAssignTo('user');
                    }
                    else {
                        setAssignTo('common')
                    }
                    setAssignTooltip(true);

                }
            })
        }
    },[jobData]);

    const closeQaErrorModal = useCallback(() => {
        setQaErrorModal(false);
        setIsDragEnabled(true);
    },[setQaErrorModal]);

    const openQaErrorModal = useCallback(() => {
        setQaErrorModal(true);
        setIsDragEnabled(false);
    },[setQaErrorModal]);

    const handleRerun = useCallback(() => {
        if (rerunLoad) return;

        const submit = (payload) => {
        loadNextJob();
        setRerunLoad(true);
        setGridFormLoader(true)
        rerunAutomationJob(payload)((response) => {
            setGridFormLoader(false)
            if (response?.status && response?.status_code === 200) {
            setRerunLoad(false);
            // deleteIndexedData("grid_data_cache");
            // deleteIndexedData("visited_pages");
            } else if (
            response?.status_code === 400 &&
            response?.errors &&
            response?.errors?.assign_user?.length > 0
            ) {
                showAlert("error", null, response?.errors?.rejection_user[0]);
            } else {
                showAlert(
                    "error",
                    null,
                    "ERROR WHILE SAVING PREVIOUS JOB",
                    {  is_errorJob: true }
                );
            }
        });
        };

        let payload = {
        job_id:jobData?.job,
        payer: values?.payer_name.trim().toUpperCase() || "",
        transaction_type: isQdxTransactionType(values?.transaction_type)
            ? "PAYMENT835"
            : values?.transaction_type,
        qdx_tranansactiontype: getQdxTransactionType(values?.transaction_type),
        work_type: getTaskType(),
        };

        if (values?.payer_name.trim() !== "") {
        Swal.fire({
            icon: "info",
            confirmButtonColor: "#6ba2b6",
            confirmButtonText: "OK",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            allowOutsideClick: false,
            backdrop: true,
            title: "All Data will be lose",
            customClass: {
            title: "swal-titleText fs-5",
            },
        }).then((result) => {
            if (result?.isConfirmed) {
            submit(payload);
            }
        });
        } else {
        // setToast({ status: true, type: "danger", message: "Payer is required." })
        }
    }, [
        rerunLoad,
        jobData,
        values,
        loadNextJob,
        setRerunLoad,
        rerunAutomationJob,
        // deleteIndexedData,
        showAlert,
        getTaskType,
        isQdxTransactionType,
        getQdxTransactionType,
    ]);


 const setDefaultValueAssignedWorkClaim = async (event,setLocalValue,setDbkValue) => {
    const index = 0
  const name = event.target.name.replace(/\.?\[(\d+)\]/g, ".$1");
  if (event.ctrlKey === true && event.keyCode === 32) {
    const base = `claims.${index}`; // shortcut prefix
    const serviceLineBase = `claims.${index}.service_lines.${activeserviceLineIndex}`; // shortcut prefix

    // account_number
    if (name === `check_number` && jobData?.default?.check_number) {
    //   eobFormSetValues(`check_number`, jobData.default.check_number);
      setLocalValue(jobData.default.check_number)
      setDbkValue(jobData.default.check_number)
    }
    else if (name === `${serviceLineBase}.code` && jobData?.default?.cpt_codes) {
    //   eobFormSetValues(`${serviceLineBase}.code`, jobData.default.cpt_codes);
      setLocalValue(jobData.default.cpt_codes)
      setDbkValue(jobData.default.cpt_codes)
    }
    else if (name === `${base}.patient_account_number` && jobData?.default?.account_number) {
    //   eobFormSetValues(`${base}.patient_account_number`, jobData.default.account_number);
      setLocalValue(jobData.default.account_number)
      setDbkValue(jobData.default.account_number)
    }

    else if (name === `${base}.payer_claim_number` && jobData?.default?.payer_claim_number) {
    //   eobFormSetValues(`${base}.payer_claim_number`, jobData.default.payer_claim_number);
      setLocalValue(jobData.default.payer_claim_number)
      setDbkValue(jobData.default.payer_claim_number)
    }
    else if (name === `${base}.patient_identifier_code` && jobData?.default?.patient_identifier) {
    //   eobFormSetValues(`${base}.patient_identifier_code`, jobData.default.patient_identifier);
      setLocalValue(jobData.default.patient_identifier)
      setDbkValue(jobData.default.patient_identifier)
    }

    // first_name
    else if (name === `${base}.patient_first_name` && jobData?.default?.first_name) {
    //   eobFormSetValues(`${base}.patient_first_name`, jobData.default.first_name);
      setLocalValue(jobData.default.first_name)
      setDbkValue(jobData.default.first_name)
    }

    // last_name
    else if (name === `${base}.patient_last_name` && jobData?.default?.last_name) {
    //   eobFormSetValues(`${base}.patient_last_name`, jobData.default.last_name);
      setLocalValue(jobData.default.last_name)
      setDbkValue(jobData.default.last_name)
    }

    // from_date
    else if (name === `${serviceLineBase}.from_date` && jobData?.default?.date_of_service) {
      const date = moment(jobData.default.date_of_service).format("MM/DD/YYYY");
    //   eobFormSetValues(`${serviceLineBase}.from_date`, date);
      setLocalValue(date)
      setDbkValue(date)
    }
    // period_start
    else if (name === `${base}.period_start` && jobData?.default?.date_of_service) {
      const date = moment(jobData.default.date_of_service).format("MM/DD/YYYY");
    //   eobFormSetValues(`${base}.period_start`, date);
      setLocalValue(date)
      setDbkValue(date)
    }

    // to_date
    else if (name === `${serviceLineBase}.to_date` && jobData?.default?.date_of_service) {
      const date = moment(jobData.default.date_of_service).format("MM/DD/YYYY");
    //   eobFormSetValues(`${serviceLineBase}.to_date`, date);
      setLocalValue(date)
      setDbkValue(date)
    }
    // period_end
    else if (name === `${base}.period_end` && jobData?.default?.date_of_service) {
      const date = moment(jobData.default.date_of_service).format("MM/DD/YYYY");
    //   eobFormSetValues(`${base}.period_end`, date);
      setLocalValue(date)
      setDbkValue(date)
    }

    // billed
    else if (name === `${base}.billed` && jobData?.default?.charge) {
      const billed = parseFloat(jobData.default.charge).toFixed(2);
    //   eobFormSetValues(`${base}.billed`, billed);
      setLocalValue(billed)
      setDbkValue(billed)
    }
  }
};

useEffect(()=>{
   if(isViewOnllyGrid&&container){
    disablingGridLog(container)
   } 
},[isViewOnllyGrid,container,showClaimSummary,additionalModal])

const createNewClaim = useCallback(() => {
  const { claims } = values;
  handleQaErrorCheck('save_or_next_or_copy')
  // Replace current claim
  replaceClaim(initialClaim);

  // Trigger validation for claims
  triggerEobValidation("claims");

  // Update fullclaimData with the latest claim
  const updatedClaimsWithLatestData = updateClaimAtIndex(
    fullclaimData,
    activeclaim835Index,
    claims[0]
  );

  // Insert a new claim after the active index
  const updatedClaim = insertClaimAtIndex(
    updatedClaimsWithLatestData,
    initialClaim[0],
    activeclaim835Index + 1
  );

  setFullClaimData(updatedClaim);

  // Update pagination and active index
  setPagenateInputVal(startClaimOrder + (activeclaim835Index + 1));
  setActiveclaim835Index((prev) => prev + 1);

  // Update totals
  handleUpdateTotalClaimPaid(
    startClaimOrder + activeclaim835Index - 1,
    "create"
  );


}, [
  fullclaimTotal,
  startClaimOrder,
  fullclaimData,
  activeclaim835Index,
  initialClaim,
  setActiveclaim835Index,
  triggerEobValidation,
  values?.claims,
]);

const createNewClaim835Lte = useCallback(() => {
const { claims } = values
handleQaErrorCheck('save_or_next_or_copy')
const newClaimReplace = {
    ...initial835LiteValues?.claims,
    page_from: currentPdfPage,
    page_to: currentPdfPage,
}

replaceClaim(newClaimReplace)
triggerEobValidation('claims')
const updatedClaimsWithLatestData = updateClaimAtIndex(fullclaimData, activeclaim835Index, claims[0]);

const newClaim = {
    ...initialClaim[0],
    page_from: currentPdfPage,
    page_to: currentPdfPage,
}
const updatedClaim = insertClaimAtIndex(updatedClaimsWithLatestData, newClaim, activeclaim835Index + 1)

setFullClaimData(updatedClaim)
setPagenateInputVal(startClaimOrder + (activeclaim835Index + 1))
setActiveclaim835Index(prev => prev + 1);         // Move active index to the newly created claim
handleUpdateTotalClaimPaid((startClaimOrder + activeclaim835Index) - 1, 'create')
}, [fullclaimTotal,startClaimOrder,fullclaimData, activeclaim835Index, initialClaim, setActiveclaim835Index,triggerEobValidation,values?.claims,currentPdfPage]);

const createNewClaimCorres = useCallback(() => {
    const { claims } = values
    handleQaErrorCheck('save_or_next_or_copy')
    const newClaimReplace = {
    ...initialCorresValues?.claims,
    page_from: currentPdfPage,
    page_to: currentPdfPage,
}
replaceClaim(newClaimReplace)
triggerEobValidation('claims')
const updatedClaimsWithLatestData = updateClaimAtIndex(fullclaimData, activeclaim835Index, claims[0]);
const newClaim = {
    ...initialClaim[0],
    page_from: currentPdfPage,
    page_to: currentPdfPage,
}

const updatedClaim = insertClaimAtIndex(updatedClaimsWithLatestData, newClaim, activeclaim835Index + 1)

setFullClaimData(updatedClaim)
setPagenateInputVal(startClaimOrder + (activeclaim835Index + 1))
setActiveclaim835Index(prev => prev + 1);         // Move active index to the newly created claim
handleUpdateTotalClaimPaid((startClaimOrder + activeclaim835Index) - 1, 'create')
}, [fullclaimTotal, startClaimOrder, fullclaimData, activeclaim835Index, initialClaim, setActiveclaim835Index, triggerEobValidation, values?.claims ,currentPdfPage]);

// For formClaimRc (Claim-level adjustments)
const onSubmitClaimAdjustment = async (values1) => {
  const data_from = 2;
  const formValues = values
  if (formValues?.payer_id) {
    try {
      const response = await createPropCode1(
        jobData?.job,
        formValues?.payer_id,
        null,
        null,
        null,
        null,
        null,
        values1.reason_code?.toUpperCase(),
        data_from,
        values1?.description?.toUpperCase(),
        values1?.rarc?.toUpperCase(),
        values1?.carc?.toUpperCase(),
        values1?.group_code
      );

      if (response && response.status) {
        var rmkField = document.querySelector(`[name="claims[${propCodeDataClaim.index}].claim_adjustments[${propCodeDataClaim.adjustmentIndex + 1}].amount"]`);
        if (rmkField) {
          rmkField.focus();
        } else {
          const aditionalInfoButton = document.getElementById("additional-btn");
          aditionalInfoButton?.focus();
        }
        closePcPopupClaim();
        
        const claims = formValues?.claims;
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].pc = values1?.reason_code?.toUpperCase();
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].rmk = values1?.rarc?.toUpperCase();
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].reason_code = values1?.carc?.toUpperCase();
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].group_code = values1?.group_code;
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].description = values1?.description;
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].reasoncode_id = response?.data?.reasoncode_id;
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].is_invalid_reason_code = "";
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].is_invalid_rmk = "";
        

          customFieldValidator([
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.pc`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.rmk`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.group_code`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.description`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.reasoncode_id`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.is_invalid_reason_code`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.is_invalid_rmk`,

        ])

        // await formEob.setValues({
        //   ...formValues,
        //   claims: claims,
        // });
        eobFormSetValues('claims',claims)
        
        loadEobFormdata(); // react-hook-form reset
        
        setTimeout(() => {
          sequestrationClaim(claims[propCodeDataClaim.index]);
          handleClaimPatresCalculation();
        }, 200);
        
        setIsDragEnabled(true);
        // setToast({ status: true, type: "success", message: "Success" });
      } else if (response?.status_code == 400 && response?.errors) {
        showAlert("error",null,response?.errors?.assign_user[0])

      } else {
        eobSetError('reason_code', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.reason_code 
        });
        eobSetError('rarc', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.rarc 
        });
        setIsDragEnabled(false);
        const popupData = {
          index: propCodeDataServiceLine.index,
          serviceIndex: propCodeDataServiceLine.serviceIndex,
          adjustmentIndex: propCodeDataServiceLine.adjustmentIndex,
        };

        // Determine if this is a service line or claim adjustment
        openPcPopupClaim(popupData);
      }
    } catch (error) {
      console.error('Error creating prop code:', error);
      // setToast({ status: true, type: "danger", message: "Failed" });
    }
  } else {
    try {
      const response = await createPropCode1(
        jobData?.job,
        null,
        formValues?.payer_name?.toUpperCase() || "",
        formValues?.payer_address?.toUpperCase() || "",
        formValues?.payer_city?.toUpperCase() || "",
        formValues?.payer_state?.toUpperCase() || "",
        formValues?.payer_zip?.toUpperCase() || "",
        values1.reason_code?.toUpperCase(),
        data_from,
        values1?.description?.toUpperCase(),
        values1?.rarc?.toUpperCase(),
        values1?.carc?.toUpperCase(),
        values1?.group_code
      );

      if (response && response.status) {
        closePcPopupClaim();
        
        const claims = formValues?.claims;
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].pc = values1?.reason_code?.toUpperCase() || "";
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].rmk = values1?.rarc?.toUpperCase() || "";
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].group_code = values1?.group_code;
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].reason_code = values1?.carc?.toUpperCase() || "";
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].description = values1?.description;
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].is_invalid_reason_code = "";
        claims[propCodeDataClaim.index].claim_adjustments[propCodeDataClaim.adjustmentIndex].is_invalid_rmk = "";
        
        // await formEob.setValues({
        //   ...formValues,
        //   payer_id: response?.data?.payer_id || "",
        //   claims: claims,
        // });
        eobFormSetValues('claims',claims)
        eobFormSetValues('payer_id',response?.data?.payer_id || "")
        
        customFieldValidator([
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.pc`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.rmk`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.group_code`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.description`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.reasoncode_id`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.is_invalid_reason_code`,
            `claims.${0}.claim_adjustments.${propCodeDataClaim.adjustmentIndex}.is_invalid_rmk`

        ])

        loadEobFormdata();
        setIsDragEnabled(true);
        
        setTimeout(() => {
          sequestrationClaim(claims[propCodeDataClaim.index]);
          handleClaimPatresCalculation();
        }, 200);
        
        // setToast({ status: true, type: "success", message: "Success" });
      } else if (response?.status_code == 400 && response?.errors) {
        showAlert("error",null,response?.errors?.assign_user[0])
      } else {
        eobSetError('reason_code', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.reason_code 
        });
        eobSetError('rarc', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.rarc 
        });
        setIsDragEnabled(false);
        const popupData = {
          index: propCodeDataServiceLine.index,
          serviceIndex: propCodeDataServiceLine.serviceIndex,
          adjustmentIndex: propCodeDataServiceLine.adjustmentIndex,
        };

        // Determine if this is a service line or claim adjustment
        openPcPopupClaim(popupData);
        // setToast({ status: true, type: "danger", message: "Failed" });
      }
    } catch (error) {
      console.error('Error creating prop code:', error);
      // setToast({ status: true, type: "danger", message: "Failed" });
    }
  }
};

// For formRc (Service line adjustments)
const onSubmitServiceLineAdjustment = async (values1) => {
  const data_from = 2;
  const formValues = values
  if (formValues?.payer_id) {
    try {
      const response = await createPropCode1(
        jobData?.job,
        formValues?.payer_id,
        null,
        null,
        null,
        null,
        null,
        values1.reason_code?.toUpperCase(),
        data_from,
        values1?.description?.toUpperCase(),
        values1?.rarc?.toUpperCase(),
        values1?.carc?.toUpperCase(),
        values1?.group_code
      );

      if (response && response.status) {
        closePcPopupServiceLine();
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.pc`, values1?.reason_code ?.toUpperCase() || "")
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.rmk`, values1?.rarc?.toUpperCase() || "")
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.reason_code`, values1?.carc?.toUpperCase() || "")
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.group_code`, values1?.group_code)
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.description`, values1?.description)
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.reasoncode_id`, response?.data?.reasoncode_id || "")
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.is_invalid_reason_code`, "")
        eobFormSetValues(`claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.is_invalid_rmk`, "")
        
        customFieldValidator([
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.pc`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.rmk`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.group_code`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.description`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.reasoncode_id`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.is_invalid_reason_code`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.is_invalid_rmk`,

        ])
        
        const focusNext = document.querySelector(`input[name="claims[${propCodeDataServiceLine.index}].service_lines[${propCodeDataServiceLine.serviceIndex}].adjustments[${propCodeDataServiceLine.adjustmentIndex}].pc"]`);
        if (focusNext) {
          focusNext.focus();
        }
        
        setTimeout(() => {
          sequestrationServiceline(formValues?.claims[propCodeDataServiceLine.index]?.service_lines[propCodeDataServiceLine.serviceIndex]);
          handlePatresCalculation();
        }, 200);
        
        setIsDragEnabled(true);
        // setToast({ status: true, type: "success", message: "Success" });
      } else if (response?.status_code == 400 && response?.errors) {
        showAlert("error",null,response?.errors?.assign_user[0])
      } else {
        eobSetError('reason_code', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.reason_code 
        });
        eobSetError('rarc', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.rarc 
        });
        setIsDragEnabled(false);
        const popupData = {
          index: propCodeDataServiceLine.index,
          serviceIndex: propCodeDataServiceLine.serviceIndex,
          adjustmentIndex: propCodeDataServiceLine.adjustmentIndex,
        };

        // Determine if this is a service line or claim adjustment
        openPcPopupServiceLine(popupData);
      }
    } catch (error) {
      console.error('Error creating prop code:', error);
      // setToast({ status: true, type: "danger", message: "Failed" });
    }
  } else {
    try {
      const response = await createPropCode1(
        jobData?.job,
        null,
        formValues?.payer_name?.toUpperCase() || "",
        formValues?.payer_address?.toUpperCase() || "",
        formValues?.payer_city?.toUpperCase() || "",
        formValues?.payer_state?.toUpperCase() || "",
        formValues?.payer_zip?.toUpperCase() || "",
        values1.reason_code?.toUpperCase(),
        data_from,
        values1?.description?.toUpperCase(),
        values1?.rarc?.toUpperCase(),
        values1?.carc?.toUpperCase(),
        values1?.group_code
      );

      if (response && response.status) {
        closePcPopupServiceLine();
        
        const claims = formValues?.claims;
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].pc = values1?.reason_code ?.toUpperCase() || "";
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].rmk = values1?.rarc?.toUpperCase() || "";
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].group_code = values1?.group_code;
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].reason_code  = values1?.carc?.toUpperCase()||'' ;
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].description = values1?.description?.toUpperCase();
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].reasoncode_id = response?.data?.reasoncode_id || "";
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].is_invalid_reason_code = "";
        claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex].adjustments[propCodeDataServiceLine.adjustmentIndex].is_invalid_rmk = "";
        
        // await formEob.setValues({
        //   ...formValues,
        //   payer_id: response?.data?.payer_id || "",
        //   claims: claims,
        // });
        eobFormSetValues('claims',claims)
        eobFormSetValues('payer_id',response?.data?.payer_id || "")
        
        customFieldValidator([
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.pc`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.rmk`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.group_code`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.description`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.reasoncode_id`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.is_invalid_reason_code`,
            `claims.${0}.service_lines.${propCodeDataServiceLine.serviceIndex}.adjustments.${propCodeDataServiceLine.adjustmentIndex}.is_invalid_rmk`

        ])
        
        const focusNext = document.querySelector(`input[name="claims[${propCodeDataServiceLine.index}].service_lines[${propCodeDataServiceLine.serviceIndex}].adjustments[${propCodeDataServiceLine.adjustmentIndex}].pc"]`);
        if (focusNext) {
          focusNext.focus();
        }
        
        setTimeout(() => {
          sequestrationServiceline(claims[propCodeDataServiceLine.index].service_lines[propCodeDataServiceLine.serviceIndex]);
          handlePatresCalculation();
        }, 200);
        
        setIsDragEnabled(true);
        // setToast({ status: true, type: "success", message: "Success" });
      } else if (response?.status_code == 400 && response?.errors) {
        showAlert("error",null,response?.errors?.assign_user[0])
      } else {
        eobSetError('reason_code', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.reason_code 
        });
        eobSetError('rarc', { 
          type: 'manual', 
          message: response?.response?.data?.errors?.rarc 
        });
        setIsDragEnabled(false);
        const popupData = {
          index: propCodeDataServiceLine.index,
          serviceIndex: propCodeDataServiceLine.serviceIndex,
          adjustmentIndex: propCodeDataServiceLine.adjustmentIndex,
        };

        // Determine if this is a service line or claim adjustment
        openPcPopupServiceLine(popupData);
        // setToast({ status: true, type: "danger", message: "Failed" });
      }
    } catch (error) {
      console.error('Error creating prop code:', error);
      // setToast({ status: true, type: "danger", message: "Failed" });
    }
  }
};


window.onkeyup = function (event) {
    // if ((event.key === "Enter" || event.keyCode === 13) && facilitySwal?.isSwal == true) {
    //   setFacilitySwal({ ...facilitySwal, isSwal: false })
    // }
    // else
       if (event.key == 'Tab' && event.ctrlKey && event.shiftKey ) {
      document.getElementById('id-ctrl-tab-shift-switch').click()
    }
    else if (event.key == 'Tab' && event.ctrlKey ) {
      document.getElementById('id-ctrl-tab-switch').click()
    }
    else if (event.altKey && event.keyCode == 78 ) {
      document.getElementById('bottom-tab-add').click()
    }
    else if (event.altKey && event.keyCode == 88 ) {
      document.getElementById('id-ctrl-x-remove-tab').click()
    }

    if (event.keyCode == 72 && event.altKey) {
      setHotKey(true);
      setIsDragEnabled(false)
    }

    if (event.keyCode == 89 && event.shiftKey && event.altKey && (jobData?.is_large_batch_job === false && jobData?.document_type?.patient_pay === true)) { //Key Y ==  89
      onTransactionTypeChange('PATIENT_PAY')
    }

    if (event.keyCode == 80 && event.shiftKey && event.altKey && jobData?.document_type?.eob === true) { // key p 80
      onTransactionTypeChange('PAYMENT835')
    }
   


  if (event.keyCode == 82 && event.altKey) {
    if (event.keyCode == 82 && event.shiftKey && event.altKey && jobData?.document_type?.correspondence === true) { //key R 82
      onTransactionTypeChange('CORRESPONDENCE')
    }
    else {
      rejectRef.current?.click(); //reject open from gridheader

    }

  }
  
  if (event.altKey && event.keyCode === 83) { // key S 83
    const saveBtn = document.getElementById("save-btn");
    if (saveBtn && !saveBtn.disabled) {
      saveBtn.click();  //  trigger SAVE
    }
  }

  if (event.altKey && event.key.toLowerCase() === "c") {
    const allocateDiv = document.querySelector('[aria-label="Allocate Values"]');

    if (allocateDiv) {
      allocateDiv.click(); // simulate click
    }
  }

  if (event.keyCode == 67 && event.shiftKey && event.altKey && document.activeElement.name?.includes('claims') ) {
    
    if (  ['PAYMENT835','PATIENT_PAY_835','CORRESPONDENCE_835' ].includes(values?.transaction_type)  ) {
      createNewClaim()
    }
    if (  ['PAYMENT835_LITE' ].includes(values?.transaction_type)  ) {
      createNewClaim835Lte()
    }
    if (  ['CORRESPONDENCE' ].includes(values?.transaction_type)  ) {
      createNewClaim835Lte()
    }
    // else if (state.Correspondence) {
    //   addingNewCorrespondanceClaim();
    //   setClaimCorresIndex(claimCorresIndex + 1);
    // }
    // else if (state.Payment835Lite) {
    //   handleNewClaim()

    //   // setClaim835Focus(false)
    // }
    // else
    return
  }
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 's') {
        event.preventDefault(); // Prevent browser default (if any)
        this.document.getElementById('sevice-line-new-button').click()
    }
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'c') {
        event.preventDefault(); // Prevent browser default (if any)
        this.document.getElementById('claim_add_btn-aaa').click()
    }


      if (event.keyCode === 27 && !patientLookup &&!payerPayeeLookup ) {
        handleChangeGridPosition({ x: -10, y: 770 });
    //     controlledPositionRef.current = { x: 0, y: 0 };
    // setTriggerGridPos((prev) => !prev);

    //   console.log(controlledPositionRef?.current,"controlledPositionRef");


      
      }
}


  const moveClaimUp = () => {
    if (moveClaimIndex === null || moveClaimIndex === 0) return;
    const newList = [...fullclaimData];
    [newList[moveClaimIndex - 1], newList[moveClaimIndex]] = [
      newList[moveClaimIndex],
      newList[moveClaimIndex - 1],
    ];
    setFullClaimData(newList);
    setMoveClaimIndex(moveClaimIndex - 1);
  };

  const moveClaimDown = () => {
    if (moveClaimIndex === null || moveClaimIndex === fullclaimData.length - 1) return;
    const newList = [...fullclaimData];
    [newList[moveClaimIndex + 1], newList[moveClaimIndex]] = [
      newList[moveClaimIndex],
      newList[moveClaimIndex + 1],
    ];
    setFullClaimData(newList);
    setMoveClaimIndex(moveClaimIndex + 1);
  };
  const setSuspenceComponentLoaded = (name,val)=>{
    setComponentLoadingState(prev => ({ ...prev, [name]: val }))
  }
  // ============================ RENDER ============================ //

  console.log(values,'values')
  console.log(eobFormErrors,'eobFormErrors')
  return (
    <React.Fragment>

      <Draggable
        // defaultPosition={controlledPositionRef.current}
        position={controlledPositionRef.current} 
        onStart={() => isDragEnabled}
        // onDrag={onDrag}
         onStop={onDrag} 
        cancel="input"
      >
        <div className="draggable" style={{ zIndex: 999 }} id='boxid-new'>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <EobFormContext.Provider value={{
                  gridRef,
                  pathname,
                  eobUseForm,
                  totalPDFPages,
                  handlePlbPageChange,
                  handlePlbPaginatedCurrentPage,
                  plbPaginatedata: { ...plbPaginatedata, currentPage: plbPage },
                  setPlbPaginateData: setPlbPage,
                  isViewOnllyGrid,
                  activeclaim835Index,
                  setActiveclaim835Index,
                  renderClaimClass,
                  activeserviceLineIndex,
                  setActiveserviceLineIndex,
                  renderServiceLineClass,
                  renderAdjustmentClass,
                  disableCorresField,
                  setIsDragEnabled,
                  serviceLineAdjustmentState,
                  claimAdjustmentState,
                  resetGrid,
                  addPlbAdjustment,
                  addAdjustment,
                  jumpToPage,
                  showClaimSummary,
                  setShowClaimSummary,
                  __moveClaim,
                  moveClaimIndex,
                  setMoveClaimIndex,
                  showCheckView,
                  setShowCheckView,
                  jobData,
                  infoModal,
                  setInfoModal,
                  plb_adjustments,
                  removePlbAdjustment,
                  claimsData,
                  removeClaim,
                  addNewClaim,
                  updateNewClaim,
                  onClaimRangeChange,
                  onPlbRangeChange,
                  onPlbLogRangeChange,
                  formValues: values,
                  handleAccountNumberKeyUp,
                  handlePayerPayeeF7KeyUp,
                  transactionPayment835,
                  transactionPatientPay,
                  transactionPatientPay835,
                  triggerEobValidation,
                  startClaimOrder,
                  paginateInputVal,
                  setPagenateInputVal,
                  fullclaimData,
                  setFullClaimData,
                  replaceClaim,
                  currentPdfPage, 
                  clearErrors,
                  eobSetError,
                  validateAllExceptIndex,
                  handleChangeSLCalculation,
                  handleSLAssignBalanceValue,
                  changeClaimValue,
                  setPartialSavePopupState,
                  fullclaimTotal,
                  setFullClaimTotal,
                  handleUpdateTotalClaimPaid,
                  handleSlCalculation,
                  handlePatresCalculation,
                  handleClaimPatresCalculation,
                  handleRemainingBalanceCalculation,
                  handleAllocateValuesServiceLine,
                  handleClaimCalculation,
                  handleColumnCalculation,
                  unblockGrid,
                  blockGrid,
                  isRarcCarcValidData,
                  setIsRarcCarcValidData,
                  handleRowCalculation,
                  generatePaymentData,
                  calculateRemainingPlbPaidTotals,
                  contextValues,
                  additionalInfoState,
                  eobFormErrors,
                  onTransactionTypeChange,
                  customFieldValidator,
                  handlePageNavigate,
                  handleClickPageFromAndTo,
                  isValidationCompleted,
                  handleLoadOrginalLoader,
                  handleReset837Loader,
                  handleLoadOriginal,
                  handleReset837,
                  handleMergeServiceline,
                  isQaScreen,
                  isMyworkScreen,
                  isViewAllPage,
                  onEobFormSubmit,
                  handleRerun,
                  rerunLoad,
                  isClaimFormValid,
                  showAlert,
                  setDefaultValueAssignedWorkClaim,
                  createNewClaim,
                  createNewClaim835Lte,
                  createNewClaimCorres,
                  onClaimLogRangeChange,
                  tableHeight,
                  onSubmitClaimAdjustment,
                  onSubmitServiceLineAdjustment,
                  isViewScreen,
                  isAutomation,
                  gotoClaim:goToIndex,
                  controlledPositionRef,
                  moveClaimUp,
                  moveClaimDown,
                  handleQaErrorCheck,
                  isSaveCurrentJobApi,
                  isPlbPaginateLoading,
                  setisPlbPaginateLoading,
          

                }}>


                  <ResizableBox
                    resizeHandles={showClaimSummary ? ['n'] : []}
                    width={undefined}
                    height={showClaimSummary ? 400 : undefined}
                    minConstraints={[100, 400]}
                    maxConstraints={[500, 900]}
                    handle={showClaimSummary ? <span className="custom-handle " /> : ""}
                    axis="y"
                    className={!showClaimSummary ? "h-auto" : ""}
                    // onResizeStart={(e) => { e.stopPropagation() }}  // can be 'x', 'y', or 'both'

                    onResizeStart={(e) => e.stopPropagation()}
                    onResize={(e, { size }) => setTableHeight(size.height)}
                    onResizeStop={(e, data) =>
                      console.log("Resize stopped. New height:", data.size.height)
                    }
                  >
                  <div ref={gridRef} id="grid-full-container" className="grid shadow h-100" style={{ position: "relative", overflow: "hidden" }}>
                    <FormProvider {...eobUseForm}>
                        {/* ===============F7 PATIENT SEARCH============== */}
                        {patientLookup?
                            <PatientSearch
                                loading={loading}
                                setLoading={setLoading}
                                __handleSearchData837={__handleSearchData837}
                                patientValue={patientValue}
                                data_837={data_837}
                                patientIndex={patientIndex}
                                hoveredIndex={hoveredIndex}
                                togglePatientHoverEnter={togglePatientHoverEnter}
                                handlePatientIndex={handlePatientIndex}
                                patientValue1={patientValue1}
                                patientValue2={patientValue2}
                                setPatientValue={setPatientValue}
                                cl837Index={cl837Index}
                                activate837={activate837}
                                setData837={setData837}
                                checkRef={checkRef}
                                handleCheckServiceLines={handleCheckServiceLines}
                                qdxTransaction={values?.transaction_type}
                                handleAllCheck={handleAllCheck} 
                            />
                        :
                        payerPayeeLookup?
                            <PayerPayeeSearch
                                payerPayeeF7Type={payerPayeeF7Type}
                                loading={loading}
                                handleSearchPayerPayee={handleSearchPayerPayee}
                                togglePayerPayeeHoverEnter={togglePayerPayeeHoverEnter}
                                activatePayerPayeeLookup={activatePayerPayeeLookup}
                                setPayerFocus={setPayerFocus}
                                setPayerPayeeLookup={setPayerPayeeLookup}
                                payerPayeeValue={payerPayeeValue}
                                payerPayeeData={payerPayeeData}
                                payerPayeeIndex={payerPayeeIndex}
                                setPayerPayeeValue={setPayerPayeeValue}
                            />
                        :
                        <React.Fragment>
                        <form id="payment-835-form" onSubmit={eobUseForm.handleSubmit(onEobFormSubmit)} className='h-100'>
                        <div className={ showClaimSummary ? 'claim-summary-header-new' : values?.transaction_type === "PAYMENT835_LITE" ?"bg-color-lite":values?.transaction_type === "PATIENT_PAY_835" ? "bg-color-pp" : "bg-color" }>

                            <SuspenseTracker
                            fallback={<div>Loading Grid Header...</div>}
                            onLoadStart={() => setSuspenceComponentLoaded('isGridHeader',false)}
                            onLoadEnd={() => setSuspenceComponentLoaded('isGridHeader',true)}
                            >
                            <GridHeader
                                eobFormRegister={eobFormRegister}
                                rejectRef={rejectRef}
                                rejectPopupState={rejectPopupState}
                                setRejectPopupState={setRejectPopupState}
                                assignRef={assignRef}
                                values={values}
                                setValue={eobFormSetValues}
                                trigger={triggerEobValidation}
                                assignTooltip={assignTooltip}
                                showAssignTooltip={showAssignTooltip}
                            />
                            </SuspenseTracker>

                            <SuspenseTracker
                            fallback={<div>Loading Grid Body...</div>}
                            onLoadStart={() => setSuspenceComponentLoaded('isEob835',false)}
                            onLoadEnd={() => setSuspenceComponentLoaded('isEob835',true)}
                            >
                            {showClaimSummary ? (
                                <ClaimSummary
                                setShowClaimSummary={setShowClaimSummary}
                                eobFormGetValues={eobFormGetValues}
                                />
                            ) : (
                                <Eob835 />
                            )}
                            </SuspenseTracker>

                        </div>

                        <SuspenseTracker
                            fallback={<div>Loading Grid Footer...</div>}
                            onLoadStart={() => setSuspenceComponentLoaded('isGridFooter',false)}
                            onLoadEnd={() => setSuspenceComponentLoaded('isGridFooter',true)}
                        >
                            <GridFooter
                            aditionalInfoRef={aditionalInfoRef}
                            handleOpenAdditionalInfo={handleOpenAdditionalInfo}
                            />
                        </SuspenseTracker>

                        <QaErrorModal 
                            isOpen={qaErrorModal} 
                            onClose={closeQaErrorModal} 
                        />
                        </form>

                        </React.Fragment>}

                        <Hotkey hotKey={hotKey} setHotKey={setHotKey} setIsDrag={setIsDragEnabled} jobData={jobData} />

                        {/* ============FOR BLOCKING GRID (DBK )========= */}
                    {
                        isBlockGrid &&
                        <BlockGrid />
                    }
                   </FormProvider>
                  </div>

                  </ResizableBox>
                </EobFormContext.Provider>
                   
              </div>
            </div>
          </div>
          
        </div>

       

      </Draggable>
      {/* ==========ASSIGN POPOVER========= */}
      <AssignBackPopover
        show={assignTooltip}
        target={assignRef.current}
        onHide={() => { setAssignTooltip(false) }}
        jobData={jobData}
        userStatus={userStatus}
        onAssignSingle={handleSingleAssign}
        onAssignMultiple={handleMultipleAssign}
        isSubmitting={true}
        subJobOptions={subJobOptions}
        setSubJobOptions={setSubJobOptions}
      />
      {/* ==========REJECT POPOVER========= */}
            {/* Reject Popup */}
      <FormPopover
        show={rejectPopupState?.open}
        target={rejectRef.current}
        onHide={() => setRejectPopupState({ open: false, rejectLabel: null, rejection_reason: null })}
        title={rejectPopupState?.rejectLabel || "Reject"}
        onSubmit={handleRejectSubmit}
        submitButtonText="Reject"
        submitButtonClass="btn btn-reject text-end"
        placeholder="Enter rejection reason..."
        name="reject"
      />

      {/* Partial Save Popup */}
      <FormPopover
        show={partialSavePopupState?.open}
        target={rejectRef.current}
        onHide={() => setPartialSavePopupState({ open: false, saveLabel: null, save_reason: null })}
        title={partialSavePopupState?.saveLabel || "Partial Save"}
        onSubmit={handlePartialSubmit}
        submitButtonText="Partial Save"
        submitButtonClass="btn btn-reject text-end"
        placeholder="Enter save reason..."
        name="partial_save"
      />
      {/* ============ADDITIONAL INFO POPOVER========= */}
      <AdditionalInfoPopover
        additionalInfoState={additionalInfoState}
        isViewOnllyGrid={isViewOnllyGrid}
        formEobValues={values}
        jobData={jobData}
      />
     

    </React.Fragment>
  );
};

export default NewGrid;